/* IISports storefront interactions */
(function () {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const labels = () => window.iiLabels || {};

  function initLucide(scope) {
    if (typeof window.lucide !== 'undefined') {
      window.lucide.createIcons();
    }
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  window.iiFormatMoney = formatMoney;

  function setImageSource(image, src) {
    if (!image || !src) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
  }

  function freeShippingThresholdCents() {
    const globalSettings = window.iiGlobalSettings || {};
    const rawThreshold = Object.prototype.hasOwnProperty.call(globalSettings, 'freeShippingThreshold')
      ? globalSettings.freeShippingThreshold
      : Object.prototype.hasOwnProperty.call(globalSettings, 'shippingThreshold')
        ? globalSettings.shippingThreshold
        : 75;
    const threshold = Number(rawThreshold);
    return Number.isFinite(threshold) && threshold > 0 ? Math.round(threshold * 100) : 0;
  }

  const RECENT_KEY = 'ii_recently_viewed';
  const predictiveCache = new Map();
  let quickViewReturnFocus = null;
  const SEARCH_SHORTCUTS = [
    { label: 'Products', query: 'products', icon: 'shopping-bag', url: () => `${root()}search?q=products&type=product&options%5Bprefix%5D=last` },
    { label: 'Guides', query: 'guides', icon: 'newspaper', url: () => `${root()}search?q=guides&type=article%2Cpage&options%5Bprefix%5D=last` },
    { label: 'Parts', icon: 'wrench', url: () => `${root()}search?q=parts&type=product&options%5Bprefix%5D=last` },
    { label: 'On sale', icon: 'tag', url: () => `${root()}search?q=sale&type=product&options%5Bprefix%5D=last` },
    { label: 'In stock', icon: 'check-circle', url: () => `${root()}search?q=in stock&type=product&options%5Bprefix%5D=last` }
  ];
  const POPULAR_SEARCHES = [
    { label: 'Bruce Lee', query: 'Bruce Lee', icon: 'disc-3' },
    { label: 'Paintball parts', query: 'paintball parts', icon: 'target' },
    { label: 'Digital downloads', query: 'digital download', icon: 'tag' },
    { label: 'DVDs', query: 'DVD', icon: 'disc' },
    { label: 'Martial arts', query: 'martial arts', icon: 'flame' }
  ];

  function storageGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  function storageRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  function storageArray(key) {
    try {
      const value = JSON.parse(storageGet(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function saveStorageArray(key, value) {
    storageSet(key, JSON.stringify(value));
  }

  function showToast(message) {
    const region = document.querySelector('[data-toast-region]');
    if (!region || !message) return;
    const toast = document.createElement('div');
    toast.className = 'ii-toast';
    toast.textContent = message;
    region.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(0.5rem)';
    }, 2400);
    setTimeout(() => toast.remove(), 2800);
  }

  function overlay() {
    return document.getElementById('ii-overlay');
  }

  function showOverlay() {
    const el = overlay();
    if (el) el.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function hideOverlay() {
    const el = overlay();
    if (el) el.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  function syncOverlayState() {
    const hasOpenSurface = Boolean(document.querySelector('.ii-sub-modal.is-open, .ii-cart-drawer.is-open, .ii-qv-modal.is-open, .ii-mobile-nav.is-open, .ii-utility-panel.is-open, .ii-mobile-search.is-open, [data-filter-panel].is-open'));
    if (hasOpenSurface) {
      showOverlay();
    } else {
      hideOverlay();
    }
  }

  function closeQuickView() {
    const modal = document.querySelector('.ii-qv-modal.is-open');
    if (!modal) return false;
    modal.classList.remove('is-open');
    syncOverlayState();
    if (quickViewReturnFocus && document.contains(quickViewReturnFocus)) {
      window.setTimeout(() => quickViewReturnFocus.focus(), 0);
    }
    quickViewReturnFocus = null;
    return true;
  }

  function closeAllModals() {
    const hadQuickView = Boolean(document.querySelector('.ii-qv-modal.is-open'));
    document.querySelectorAll('.ii-sub-modal.is-open, .ii-cart-drawer.is-open, .ii-qv-modal.is-open, .ii-mobile-nav.is-open, .ii-utility-panel.is-open, .ii-mobile-search.is-open, [data-filter-panel].is-open').forEach((el) => {
      el.classList.remove('is-open');
    });
    closeMegaMenus();
    document.querySelectorAll('[aria-expanded="true"]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
    document.querySelectorAll('#ii-hamburger').forEach((el) => el.setAttribute('aria-label', 'Open menu'));
    hideOverlay();
    if (hadQuickView && quickViewReturnFocus && document.contains(quickViewReturnFocus)) {
      window.setTimeout(() => quickViewReturnFocus.focus(), 0);
    }
    quickViewReturnFocus = null;
  }

  function closeMegaMenus() {
    document.querySelectorAll('[data-mega-item].is-open, [data-mega-panel].is-open').forEach((el) => {
      el.classList.remove('is-open');
    });
    document.querySelectorAll('[data-mega-trigger][aria-expanded="true"]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function passwordScore(value) {
    const password = String(value || '');
    let score = 0;
    if (password.length >= 8) score += 1;
    if (password.length >= 12) score += 1;
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
    if (/\d/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;
    return Math.min(score, 5);
  }

  function updatePasswordStrength(input) {
    const field = input.closest('[data-field]') || input.parentElement;
    if (!field) return;
    const score = passwordScore(input.value);
    const width = [0, 22, 42, 64, 82, 100][score] || 0;
    const color = score <= 2 ? '#E63946' : score <= 4 ? '#F4A623' : '#7BD88F';
    const label = score <= 1 ? 'Weak password' : score <= 3 ? 'Good start. Add length or symbols.' : 'Strong password';
    field.style.setProperty('--ii-strength', `${width}%`);
    field.style.setProperty('--ii-strength-color', color);
    const bar = field.querySelector('[data-strength-bar]');
    if (bar) bar.style.width = `${width}%`;
    const text = field.querySelector('[data-strength-text]');
    if (text && input.value) text.textContent = label;
  }

  function validateAccountForm(form) {
    let valid = true;
    form.querySelectorAll('[data-field]').forEach((field) => {
      const input = field.querySelector('input, select, textarea');
      if (!input) return;
      let error = '';
      if (input.hasAttribute('required') && !String(input.value || '').trim()) error = 'This field is required.';
      if (!error && input.matches('[data-validate-email]') && input.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) error = 'Enter a valid email.';
      if (!error && input.matches('[data-validate-password]') && passwordScore(input.value) < 2) error = 'Password needs at least 8 characters.';
      field.classList.toggle('has-error', Boolean(error));
      const errorEl = field.querySelector('[data-error]');
      if (errorEl && error) errorEl.textContent = error;
      if (error) valid = false;
    });
    return valid;
  }

  function filterAccountOrders(scope) {
    const rootScope = scope || document;
    rootScope.querySelectorAll('[data-account-orders]').forEach((table) => {
      const card = table.closest('.ii-account-page__card') || document;
      const search = card.querySelector('[data-account-order-search]');
      const status = card.querySelector('[data-account-order-status]');
      const query = search ? search.value.trim().toLowerCase() : '';
      const statusValue = status ? status.value : '';
      let visibleCount = 0;
      table.querySelectorAll('[data-order-row]').forEach((row) => {
        const haystack = row.getAttribute('data-order-search') || '';
        const rowStatus = row.getAttribute('data-order-status') || '';
        const matchesQuery = !query || haystack.includes(query);
        const matchesStatus = !statusValue || rowStatus === statusValue;
        const visible = matchesQuery && matchesStatus;
        row.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      const empty = card.querySelector('[data-account-order-empty]');
      if (empty) empty.hidden = visibleCount > 0;
    });
  }

  function initMobileMenu(scope) {
    const rootScope = scope || document;
    rootScope.querySelectorAll('#ii-hamburger').forEach((hamburger) => {
      if (hamburger.dataset.iiBound) return;
      hamburger.dataset.iiBound = 'true';
      hamburger.addEventListener('click', () => {
        const mobileNav = document.getElementById('ii-mobile-nav');
        if (!mobileNav) return;
        const nextOpen = !mobileNav.classList.contains('is-open');
        mobileNav.classList.toggle('is-open', nextOpen);
        hamburger.setAttribute('aria-expanded', String(nextOpen));
        hamburger.setAttribute('aria-label', nextOpen ? 'Close menu' : 'Open menu');
        if (nextOpen) showOverlay();
        else hideOverlay();
      });
    });
  }

  function initMegaMenus(scope) {
    const rootScope = scope || document;
    rootScope.querySelectorAll('[data-mega-item]').forEach((item) => {
      if (item.dataset.iiMegaBound) return;
      item.dataset.iiMegaBound = 'true';
      const trigger = item.querySelector('[data-mega-trigger]');
      const panel = item.querySelector('[data-mega-panel]');
      if (!trigger || !panel) return;
      let closeTimer;
      let openTimer;
      const isTouchLike = () => window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;

      const open = () => {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        document.querySelectorAll('[data-mega-item].is-open').forEach((other) => {
          if (other !== item) {
            other.classList.remove('is-open');
            const otherTrigger = other.querySelector('[data-mega-trigger]');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      };

      const close = () => {
        clearTimeout(openTimer);
        item.classList.remove('is-open');
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      };

      const scheduleOpen = () => {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = window.setTimeout(open, 80);
      };

      const scheduleClose = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!item.matches(':hover') && !item.contains(document.activeElement)) close();
        }, 180);
      };

      item.addEventListener('mouseenter', scheduleOpen);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', scheduleClose);
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === ' ') {
          event.preventDefault();
          open();
          const firstLink = panel.querySelector('a[href], button:not([disabled])');
          if (firstLink) firstLink.focus();
        }
      });
      trigger.addEventListener('click', (event) => {
        if (!isTouchLike() || item.classList.contains('is-open')) return;
        event.preventDefault();
        open();
      });
      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          trigger.focus();
          return;
        }
        if (event.key === 'Tab' && item.classList.contains('is-open')) {
          const focusable = [trigger].concat(Array.from(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')))
            .filter((el) => el.offsetParent !== null || el === document.activeElement);
          if (focusable.length > 1) {
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
          return;
        }
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        const triggers = Array.from(document.querySelectorAll('[data-mega-trigger]'));
        const index = triggers.indexOf(trigger);
        if (index === -1) return;
        event.preventDefault();
        close();
        const nextIndex = event.key === 'ArrowRight'
          ? (index + 1) % triggers.length
          : (index - 1 + triggers.length) % triggers.length;
        triggers[nextIndex].focus();
      });
    });
  }

  function initAccordions(scope) {
    const rootScope = scope || document;
    rootScope.querySelectorAll('.ii-accordion-trigger').forEach((trigger) => {
      if (trigger.dataset.iiBound) return;
      trigger.dataset.iiBound = 'true';
      trigger.addEventListener('click', () => {
        const content = trigger.nextElementSibling;
        if (!content || !content.classList.contains('ii-accordion-content')) return;
        const nextOpen = !content.classList.contains('is-expanded');
        trigger.classList.toggle('is-expanded', nextOpen);
        content.classList.toggle('is-expanded', nextOpen);
        trigger.setAttribute('aria-expanded', String(nextOpen));
      });
    });

      rootScope.querySelectorAll('.ii-footer__col:not(.ii-footer__col--no-collapse) .ii-footer__col-title').forEach((trigger) => {
      if (trigger.dataset.iiBound) return;
      trigger.dataset.iiBound = 'true';
      trigger.addEventListener('click', () => {
        if (window.innerWidth >= 768) return;
        const content = trigger.nextElementSibling;
        if (!content) return;
        const nextOpen = !content.classList.contains('is-open');
        trigger.classList.toggle('is-open', nextOpen);
        content.classList.toggle('is-open', nextOpen);
      });
    });

    rootScope.querySelectorAll('#ii-mobile-nav .ii-accordion-trigger').forEach((trigger, index) => {
      const content = trigger.nextElementSibling;
      if (!content || !content.classList.contains('ii-accordion-content')) return;
      if (!content.id) content.id = `ii-mobile-accordion-${index}`;
      trigger.setAttribute('aria-controls', content.id);
      content.setAttribute('role', 'region');
      const label = trigger.textContent && trigger.textContent.trim();
      if (label && !content.getAttribute('aria-label')) content.setAttribute('aria-label', label);
    });
  }

  function openSubModal(triggerId) {
    const modal = document.getElementById('ii-sub-modal');
    const title = document.getElementById('ii-sub-modal-title');
    const meta = document.getElementById('ii-sub-modal-meta');
    const grid = document.getElementById('ii-sub-modal-grid');
    const viewAll = document.getElementById('ii-sub-modal-view-all');
    const data = window.iiSubModalData && window.iiSubModalData[triggerId];
    if (!modal || !grid || !data) return;

    if (title) title.textContent = data.title || 'Select Category';
    if (meta) meta.textContent = data.count ? `${data.count} products` : '';
    grid.innerHTML = (data.links || []).map((link) => {
      const count = link.count ? `<span class="ii-sub-modal__count">${escapeHtml(link.count)} items</span>` : '<i data-lucide="arrow-right" style="width:1rem;height:1rem;opacity:0.5;"></i>';
      const icon = link.icon ? `<i data-lucide="${escapeAttr(link.icon)}" style="width:1rem;height:1rem;color:var(--ii-primary);"></i>` : '';
      return `
        <a href="${escapeAttr(link.url)}" class="ii-sub-modal__link">
          <span>${icon}${escapeHtml(link.title)}</span>
          ${count}
        </a>
      `;
    }).join('');
    if (viewAll) {
      viewAll.innerHTML = data.url ? `<a href="${escapeAttr(data.url)}" class="ii-btn-primary" style="margin-top:1.5rem;width:100%;justify-content:center;">View All ${escapeHtml(data.title || '')}</a>` : '';
    }
    modal.classList.add('is-open');
    showOverlay();
    initLucide(modal);
    const closeButton = modal.querySelector('[data-modal-close]');
    if (closeButton) closeButton.focus();
  }

  function initSubcollectionModals(scope) {
    const rootScope = scope || document;
    rootScope.querySelectorAll('[data-sub-trigger]').forEach((trigger) => {
      if (trigger.dataset.iiBound) return;
      trigger.dataset.iiBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openSubModal(trigger.getAttribute('data-sub-trigger'));
      });
    });
  }

  function cartSettings() {
    return window.iiCartSettings || {};
  }
  let cartNoteTimer;
  let cartAttributesTimer;
  const cartProductCache = new Map();

  function updateCartCount(count) {
    document.querySelectorAll('.ii-cart-count').forEach((bubble) => {
      bubble.textContent = count;
      bubble.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function announceCart(message) {
    const drawer = cartDrawer();
    const live = drawer && drawer.querySelector('[data-cart-live]');
    if (live && message) live.textContent = message;
  }

  function cartDrawer() {
    return document.getElementById('ii-cart-drawer');
  }

  function openCart() {
    const drawer = cartDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    showOverlay();
    fetchCart();
    const closeButton = drawer.querySelector('[data-cart-close]');
    if (closeButton) closeButton.focus();
  }

  window.iiOpenCart = openCart;

  function renderShippingBar(cart) {
    const settings = cartSettings();
    if (!settings.showShippingBar) return '';
    const threshold = freeShippingThresholdCents();
    const cartTotal = Math.max(Number(cart && cart.total_price) || 0, 0);
    if (threshold <= 0) {
      return `
        <div class="ii-cart__shipping is-success" style="--ii-cart-progress:100%;">
          <div class="ii-cart__shipping-msg" style="color:#4CAF50;"><i data-lucide="party-popper" style="width:0.875rem;height:0.875rem;vertical-align:middle;"></i> ${escapeHtml(settings.freeShippingUnlockedText || 'You qualify for free shipping!')}</div>
          <div class="ii-cart__shipping-bar">
            <div class="ii-cart__shipping-progress is-success" style="width:100%"></div>
            <span class="ii-cart__shipping-truck" aria-hidden="true"><i data-lucide="truck"></i></span>
          </div>
          <div class="ii-cart__shipping-meta"><span>${formatMoney(cartTotal)}</span><span>${formatMoney(threshold)}</span></div>
        </div>
      `;
    }
    const progress = Math.min((cartTotal / threshold) * 100, 100);
    const progressStyle = `${progress}%`;
    const amountLeft = Math.max(threshold - cartTotal, 0);
    if (amountLeft > 0) {
      const text = (settings.freeShippingText || "You're [amount] away from free shipping.").replace('[amount]', formatMoney(amountLeft));
      return `
        <div class="ii-cart__shipping" style="--ii-cart-progress:${progressStyle};">
          <div class="ii-cart__shipping-msg"><i data-lucide="sparkles" style="width:0.875rem;height:0.875rem;"></i>${escapeHtml(text)}</div>
          <div class="ii-cart__shipping-bar">
            <div class="ii-cart__shipping-progress" style="width:${progressStyle}"></div>
            <span class="ii-cart__shipping-truck" aria-hidden="true"><i data-lucide="truck"></i></span>
          </div>
          <div class="ii-cart__shipping-meta"><span>${formatMoney(cartTotal)}</span><span>${formatMoney(threshold)}</span></div>
          ${renderThresholdSuggestions(cart, amountLeft)}
        </div>
      `;
    }
    return `
      <div class="ii-cart__shipping is-success" style="--ii-cart-progress:100%;">
        <div class="ii-cart__shipping-msg" style="color:#4CAF50;"><i data-lucide="party-popper" style="width:0.875rem;height:0.875rem;vertical-align:middle;"></i> ${escapeHtml(settings.freeShippingUnlockedText || 'You qualify for free shipping!')}</div>
        <div class="ii-cart__shipping-bar">
          <div class="ii-cart__shipping-progress is-success" style="width:100%"></div>
          <span class="ii-cart__shipping-truck" aria-hidden="true"><i data-lucide="truck"></i></span>
        </div>
        <div class="ii-cart__shipping-meta"><span>${formatMoney(cartTotal)}</span><span>${formatMoney(threshold)}</span></div>
      </div>
    `;
  }

  function cartNicheScore(product, cart) {
    const haystack = `${product.type || product.product_type || ''} ${(product.tags || []).join(' ')} ${product.title || ''}`.toLowerCase();
    let score = 0;
    cart.items.forEach((item) => {
      const itemText = `${item.product_type || ''} ${(item.tags || []).join(' ')} ${item.product_title || ''}`.toLowerCase();
      if (haystack && itemText) {
        if (haystack.includes('martial') && itemText.includes('martial')) score += 3;
        if (haystack.includes('paintball') && itemText.includes('paintball')) score += 3;
        if ((haystack.includes('dvd') || haystack.includes('book') || haystack.includes('media')) && (itemText.includes('martial') || itemText.includes('dvd') || itemText.includes('book'))) score += 2;
        if ((haystack.includes('part') || haystack.includes('accessor') || haystack.includes('gear')) && itemText.includes('paintball')) score += 2;
        if ((product.type || product.product_type) && item.product_type && (product.type || product.product_type) === item.product_type) score += 2;
      }
    });
    return score;
  }

  function cartItemSignature(item) {
    return `${item && item.vendor ? item.vendor : ''}|${item && item.product_type ? item.product_type : ''}`;
  }

  function cartRecommendationSeeds(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items.filter((item) => item && item.product_id) : [];
    if (items.length === 0) return [];
    const seeds = [];
    const addSeed = (item) => {
      if (!item || seeds.some((seed) => Number(seed.product_id) === Number(item.product_id))) return;
      seeds.push(item);
    };

    const lastVariantId = storageGet('ii_last_added_variant_id');
    addSeed(items.find((item) => lastVariantId && Number(item.variant_id) === Number(lastVariantId)));
    addSeed(items[0]);
    addSeed(items.slice().sort((a, b) => Number(b.final_line_price || b.line_price || b.price || 0) - Number(a.final_line_price || a.line_price || a.price || 0))[0]);

    const seenSignatures = new Set(seeds.map(cartItemSignature));
    addSeed(items.find((item) => {
      const signature = cartItemSignature(item);
      return signature && !seenSignatures.has(signature);
    }));

    return seeds.slice(0, 3);
  }

  function cartCandidates(cart) {
    const products = (window.iiCartUpsells || []).filter((product) => product && product.available && product.id);
    const cartHandles = new Set((cart.items || []).map((item) => item.handle));
    const cartProductIds = new Set((cart.items || []).map((item) => Number(item.product_id)));
    return products
      .filter((product) => !cartHandles.has(product.handle) && !cartProductIds.has(Number(product.productId)))
      .sort((a, b) => {
        const scoreDiff = cartNicheScore(b, cart) - cartNicheScore(a, cart);
        if (scoreDiff !== 0) return scoreDiff;
        return Number(a.price || 0) - Number(b.price || 0);
      });
  }

  function renderThresholdSuggestions(cart, amountLeft) {
    const settings = cartSettings();
    const picks = cartCandidates(cart)
      .filter((product) => Number(product.price || 0) >= amountLeft)
      .sort((a, b) => Number(a.price || 0) - Number(b.price || 0))
      .slice(0, 2);
    if (picks.length === 0) return '';
    return `
      <div class="ii-cart__threshold-picks">
        <div class="ii-cart__threshold-title">${escapeHtml(settings.thresholdSuggestionsHeading || 'Add one of these to unlock free shipping')}</div>
        ${picks.map((product) => `
          <div class="ii-cart__upsell-item">
            ${product.image ? `<img class="ii-cart__upsell-img" src="${escapeAttr(product.image)}" alt="${escapeAttr(product.title)}">` : '<div class="ii-cart__upsell-img"></div>'}
            <div class="ii-cart__upsell-copy">
              <a class="ii-cart__upsell-name" href="${escapeAttr(product.url)}">${escapeHtml(product.title)}</a>
              <div class="ii-cart__upsell-price">${formatMoney(product.price)}</div>
            </div>
            <button type="button" class="ii-btn-primary ii-cart__upsell-add" data-cart-add="${escapeAttr(product.id)}">Add</button>
          </div>
        `).join('')}
      </div>
    `;
  }

  function renderUpsells(cart) {
    const settings = cartSettings();
    const picks = settings.showUpsell ? cartCandidates(cart).slice(0, 3) : [];

    if (picks.length === 0) return '';

    return `
      <div class="ii-cart__upsells">
        <div class="ii-cart__upsell-title">${escapeHtml(settings.upsellHeading || 'You Might Also Like')}</div>
        ${picks.map((product) => `
          <div class="ii-cart__upsell-item">
            ${product.image ? `<img class="ii-cart__upsell-img" src="${escapeAttr(product.image)}" alt="${escapeAttr(product.title)}">` : '<div class="ii-cart__upsell-img"></div>'}
            <div class="ii-cart__upsell-copy">
              <a class="ii-cart__upsell-name" href="${escapeAttr(product.url)}">${escapeHtml(product.title)}</a>
              <div class="ii-cart__upsell-price">${formatMoney(product.price)}</div>
            </div>
            <button type="button" class="ii-btn-primary ii-cart__upsell-add" data-cart-add="${escapeAttr(product.id)}">Add</button>
          </div>
        `).join('')}
        ${picks.length > 1 ? `<button type="button" class="ii-btn-primary ii-cart__bundle-add" data-cart-add-bundle="${escapeAttr(picks.map((product) => product.id).join(','))}">${escapeHtml(settings.bundleAddText || 'Add suggested bundle')}</button>` : ''}
      </div>
    `;
  }

  function renderCartRecommendationShell(cart) {
    const settings = cartSettings();
    if (settings.showRecommendations === false) return '';
    const seeds = cartRecommendationSeeds(cart);
    if (seeds.length === 0) return '';
    return `
      <div class="ii-cart__recommendations" data-cart-recommendations data-limit="4">
        <div class="ii-cart__upsell-title">${escapeHtml(settings.recommendationsHeading || 'Recommended for your cart')}</div>
        <div class="ii-cart__recommendation-list" data-cart-recommendation-list></div>
      </div>
    `;
  }

  function firstAvailableVariant(product) {
    const variants = Array.isArray(product && product.variants) ? product.variants : [];
    return variants.find((variant) => variant && variant.available !== false) || variants[0] || null;
  }

  function normalizeRecommendationProduct(product, metaLabel) {
    const variant = firstAvailableVariant(product);
    return {
      id: product && product.id,
      handle: product && product.handle,
      title: product && product.title,
      url: product && product.url,
      image: product && (product.featured_image || product.image),
      price: product && product.price,
      compareAtPrice: product && product.compare_at_price,
      vendor: product && product.vendor,
      available: product && product.available,
      variants: product && product.variants,
      variantId: variant && variant.id,
      metaLabel: metaLabel || 'Recommended'
    };
  }

  function fetchProductRecommendations(productId, limit, intents) {
    const queue = Array.isArray(intents) && intents.length ? intents : ['complementary', 'related'];
    const run = (index) => {
      const intent = queue[index];
      if (!intent) return Promise.resolve([]);
      const url = `${root()}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&intent=${encodeURIComponent(intent)}`;
      return fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error('Unable to load recommendations.');
          return res.json();
        })
        .then((data) => {
          const products = data && Array.isArray(data.products) ? data.products : [];
          return products.length > 0
            ? products.map((product) => Object.assign({}, product, { _iiRecommendationIntent: intent, _iiSeedProductId: productId }))
            : run(index + 1);
        })
        .catch(() => run(index + 1));
    };
    return run(0);
  }

  function fetchRecommendationIntent(productId, limit, intent, seedRank) {
    const url = `${root()}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&intent=${encodeURIComponent(intent)}`;
    return fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error('Unable to load recommendations.');
        return res.json();
      })
      .then((data) => {
        const products = data && Array.isArray(data.products) ? data.products : [];
        return products.map((product) => Object.assign({}, product, {
          _iiRecommendationIntent: intent,
          _iiSeedProductId: productId,
          _iiSeedRank: seedRank
        }));
      })
      .catch(() => []);
  }

  function productTextTokens(value) {
    return String(value || '')
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter((token) => token.length > 2 && !['the', 'and', 'for', 'with', 'from', 'this', 'that'].includes(token));
  }

  function recommendationScore(product, cart) {
    const cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    const productType = product.type || product.product_type || '';
    const productVendor = product.vendor || '';
    const productTokens = new Set(productTextTokens(`${product.title || ''} ${productType} ${productVendor} ${(product.tags || []).join(' ')}`));
    let score = 0;

    if (product._iiRecommendationIntent === 'complementary') score += 10;
    if (product._iiRecommendationIntent === 'related') score += 5;
    score += Math.max(0, 3 - Number(product._iiSeedRank || 0));
    score += cartNicheScore(product, cart);

    cartItems.forEach((item) => {
      if (productVendor && item.vendor && productVendor === item.vendor) score += 3;
      if (productType && item.product_type && productType === item.product_type) score += 4;

      const itemTokens = new Set(productTextTokens(`${item.product_title || ''} ${item.product_type || ''} ${item.vendor || ''}`));
      productTokens.forEach((token) => {
        if (itemTokens.has(token)) score += 0.5;
      });
    });

    const recentHandles = new Set(recentProducts().map((item) => item && item.handle).filter(Boolean));
    if (product.handle && recentHandles.has(product.handle)) score += 1.5;

    return score;
  }

  function rankedCartRecommendations(cart, limit) {
    const seeds = cartRecommendationSeeds(cart);
    const cartProductIds = new Set((cart.items || []).map((item) => Number(item.product_id)));
    const cartHandles = new Set((cart.items || []).map((item) => item.handle));
    const requestLimit = Math.min(10, Math.max(4, Number(limit || 4) * 2));
    const requests = [];

    seeds.forEach((seed, index) => {
      requests.push(fetchRecommendationIntent(seed.product_id, requestLimit, 'complementary', index));
      requests.push(fetchRecommendationIntent(seed.product_id, requestLimit, 'related', index));
    });

    return Promise.all(requests).then((groups) => {
      const byKey = new Map();
      groups.flat().forEach((product) => {
        if (!product || cartProductIds.has(Number(product.id)) || cartHandles.has(product.handle)) return;
        const key = product.handle || String(product.id || '');
        if (!key) return;
        const score = recommendationScore(product, cart);
        const existing = byKey.get(key);
        if (!existing || score > existing._iiScore) {
          byKey.set(key, Object.assign({}, product, { _iiScore: score }));
        }
      });

      cartCandidates(cart).forEach((product) => {
        const key = product.handle || String(product.productId || product.id || '');
        if (!key || byKey.has(key)) return;
        byKey.set(key, Object.assign({}, product, {
          _iiRecommendationIntent: 'curated',
          _iiScore: recommendationScore(product, cart) + 1
        }));
      });

      return Array.from(byKey.values())
        .sort((a, b) => Number(b._iiScore || 0) - Number(a._iiScore || 0))
        .slice(0, limit);
    });
  }

  function renderCartRecommendationItem(product) {
    const item = normalizeRecommendationProduct(product, 'Recommended');
    const variant = firstAvailableVariant(product) || (product && product.id ? { id: product.id, available: product.available !== false } : null);
    if (!item.handle || !item.title || !variant || !variant.id) return '';
    const price = Number(variant.price != null ? variant.price : item.price || 0);
    const compareAtPrice = Number(variant.compare_at_price != null ? variant.compare_at_price : item.compareAtPrice || 0);
    const hasSavings = compareAtPrice > price;
    const savingsPercent = hasSavings ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice) : 0;
    const priceHtml = hasSavings
      ? `
        <div class="ii-cart__upsell-price ii-cart__upsell-price--sale">
          <del class="ii-cart__upsell-compare">${formatMoney(compareAtPrice)}</del>
          <span>${formatMoney(price)}</span>
          <span class="ii-cart__upsell-save">${escapeHtml(labels().save || 'SAVE')} ${savingsPercent}%</span>
        </div>
      `
      : `<div class="ii-cart__upsell-price">${formatMoney(price || item.price || 0)}</div>`;
    return `
      <div class="ii-cart__upsell-item ii-cart__recommendation-item">
        ${item.image ? `<img class="ii-cart__upsell-img" src="${escapeAttr(item.image)}" alt="${escapeAttr(item.title)}">` : '<div class="ii-cart__upsell-img"></div>'}
        <div class="ii-cart__upsell-copy">
          <a class="ii-cart__upsell-name" href="${escapeAttr(item.url || '#')}">${escapeHtml(item.title)}</a>
          ${priceHtml}
        </div>
        <div class="ii-cart__recommendation-actions">
          <button type="button" class="ii-btn-secondary ii-cart__recommendation-quick" data-quick-view="${escapeAttr(item.url || '#')}" aria-label="Quick view ${escapeAttr(item.title)}"><i data-lucide="eye"></i></button>
          <button type="button" class="ii-btn-primary ii-cart__upsell-add" data-cart-add="${escapeAttr(variant.id)}" ${product.available === false || variant.available === false ? 'disabled' : ''}>Add</button>
        </div>
      </div>
    `;
  }

  function initCartRecommendations(cart) {
    const container = document.querySelector('[data-cart-recommendations]');
    if (!container || container.dataset.iiLoaded) return;
    const list = container.querySelector('[data-cart-recommendation-list]');
    const limit = Number(container.getAttribute('data-limit') || 4);
    if (!list) return;
    container.dataset.iiLoaded = 'true';
    rankedCartRecommendations(cart, limit)
      .then((products) => {
        if (products.length === 0) {
          container.remove();
          return;
        }
        list.innerHTML = products.map(renderCartRecommendationItem).join('');
        if (!list.innerHTML.trim()) {
          container.remove();
          return;
        }
        initLucide(container);
      });
  }

  function lineDiscountsHtml(item) {
    const discounts = Array.isArray(item.discounts) ? item.discounts : [];
    if (discounts.length === 0) return '';
    return `
      <div class="ii-cart__line-discounts">
        ${discounts.map((discount) => `
          <span><i data-lucide="tag"></i> ${escapeHtml(discount.title || 'Discount')} - ${formatMoney(discount.amount || 0)}</span>
        `).join('')}
      </div>
    `;
  }

  function cartItemAlertsHtml(item) {
    const alerts = [];
    if (item.available === false) alerts.push('This item may no longer be available.');
    if (item.quantity_rule && Number(item.quantity_rule.maximum || 0) > 0 && item.quantity >= Number(item.quantity_rule.maximum)) {
      alerts.push(`Maximum quantity is ${item.quantity_rule.maximum}.`);
    }
    if (item.properties && item.properties._stock_warning) alerts.push(String(item.properties._stock_warning));
    if (alerts.length === 0) return '';
    return alerts.map((alert) => `<div class="ii-cart__item-alert"><i data-lucide="alert-triangle"></i>${escapeHtml(alert)}</div>`).join('');
  }

  function renderCartSummary(cart) {
    const originalTotal = Number(cart.original_total_price || cart.items_subtotal_price || cart.total_price || 0);
    const totalDiscount = Number(cart.total_discount || 0);
    const total = Number(cart.total_price || 0);
    const showOriginal = originalTotal > total;
    return `
      <div class="ii-cart__summary">
        ${showOriginal ? `
          <div class="ii-cart__summary-row">
            <span>Items subtotal</span>
            <span>${formatMoney(originalTotal)}</span>
          </div>
        ` : ''}
        ${totalDiscount > 0 ? `
          <div class="ii-cart__summary-row ii-cart__summary-row--discount">
            <span>Discounts</span>
            <span>-${formatMoney(totalDiscount)}</span>
          </div>
        ` : ''}
        <div class="ii-cart__summary-row ii-cart__summary-row--total">
          <span>Subtotal</span>
          <span>${formatMoney(total)}</span>
        </div>
      </div>
    `;
  }

  function renderDiscountNotice() {
    return `
      <div class="ii-cart__discount">
        <div class="ii-cart__discount-help"><strong>Discount codes apply at checkout.</strong> Cart totals shown here are before discount codes.</div>
      </div>
    `;
  }

  function renderCartNotice() {
    const text = cartSettings().cartNoticeText;
    if (!text) return '';
    return `<div class="ii-cart__notice"><i data-lucide="alert-circle"></i><span>${escapeHtml(text)}</span></div>`;
  }

  function renderTrustBadges() {
    const settings = cartSettings();
    if (!settings.showTrustBadges) return '';
    const badges = [
      { icon: 'lock-keyhole', text: settings.trustBadge1Text || 'Secure checkout' },
      { icon: 'headphones', text: settings.trustBadge2Text || 'Specialist support' },
      { icon: 'rotate-ccw', text: settings.trustBadge3Text || 'Easy returns' }
    ].filter((badge) => badge.text);
    if (badges.length === 0) return '';
    return `
      <div class="ii-cart__trust">
        ${badges.map((badge) => `<div class="ii-cart__trust-item"><i data-lucide="${escapeAttr(badge.icon)}"></i><span>${escapeHtml(badge.text)}</span></div>`).join('')}
      </div>
    `;
  }

  function renderRecentlyViewedCart(cart) {
    const settings = cartSettings();
    if (!settings.showRecentlyViewed) return '';
    const cartHandles = new Set((cart.items || []).map((item) => item.handle));
    const picks = recentProducts().filter((item) => item && !cartHandles.has(item.handle)).slice(0, 4);
    if (picks.length === 0) return '';
    return `
      <div class="ii-cart__recent">
        <div class="ii-cart__upsell-title">${escapeHtml(settings.recentlyViewedHeading || 'Recently viewed')}</div>
        <div class="ii-cart__recent-list">
          ${picks.map((product) => {
            const item = normalizeStoredProduct(product);
            const variants = Array.isArray(product.variants) ? product.variants : [];
            const firstAvailableVariant = variants.find((variant) => variant && variant.available !== false) || variants[0];
            const variantId = item.variantId || product.variantId || product.variant_id || (firstAvailableVariant && firstAvailableVariant.id);
            const available = product.available !== false && (!firstAvailableVariant || firstAvailableVariant.available !== false);
            const quickAdd = variantId
              ? `<button type="button" class="ii-cart__recent-add" data-cart-add="${escapeAttr(variantId)}" ${available ? '' : 'disabled'}>${escapeHtml(available ? 'Quick add' : (labels().soldOut || 'Sold out'))}</button>`
              : item.handle
                ? `<button type="button" class="ii-cart__recent-add" data-cart-add-recent="${escapeAttr(item.handle)}">Quick add</button>`
                : `<a class="ii-cart__recent-add" href="${escapeAttr(item.url || '#')}">View</a>`;
            return `
              <div class="ii-cart__recent-item">
                ${item.image ? `<img class="ii-cart__recent-img" src="${escapeAttr(item.image)}" alt="${escapeAttr(item.title)}" loading="lazy">` : '<span class="ii-cart__recent-img"></span>'}
                <span>
                  <a class="ii-cart__recent-name" href="${escapeAttr(item.url || '#')}">${escapeHtml(item.title)}</a>
                  ${item.priceText ? `<span class="ii-cart__recent-price">${item.priceText}</span>` : ''}
                  ${quickAdd}
                </span>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `;
  }

  function renderEmptyCartTools() {
    const settings = cartSettings();
    const searchUrl = settings.searchUrl || `${root()}search`;
    const chips = [
      { label: 'Martial arts', url: `${searchUrl}?q=martial%20arts&type=product&options%5Bprefix%5D=last` },
      { label: 'Paintball', url: `${searchUrl}?q=paintball&type=product&options%5Bprefix%5D=last` },
      { label: 'DVDs', url: `${searchUrl}?q=DVD&type=product&options%5Bprefix%5D=last` },
      { label: 'Parts', url: `${searchUrl}?q=parts&type=product&options%5Bprefix%5D=last` }
    ];
    return `
      <div class="ii-cart__empty-search">
        <form action="${escapeAttr(searchUrl)}" method="get" class="ii-cart__empty-search-form" role="search">
          <input class="ii-cart__input" type="search" name="q" placeholder="Search products">
          <input type="hidden" name="type" value="product">
          <input type="hidden" name="options[prefix]" value="last">
          <button type="submit" class="ii-cart__discount-btn" aria-label="Search"><i data-lucide="search"></i></button>
        </form>
      </div>
      <div class="ii-cart__empty-categories">
        <div class="ii-cart__upsell-title">Popular categories</div>
        <div class="ii-cart__empty-category-list">
          ${chips.map((chip) => `<a class="ii-cart__empty-chip" href="${escapeAttr(chip.url)}">${escapeHtml(chip.label)}</a>`).join('')}
        </div>
      </div>
    `;
  }

  function renderCart(cart) {
    const content = document.getElementById('ii-cart-drawer-content');
    const settings = cartSettings();
    if (!content) return;

    if (cart.item_count === 0) {
      const primaryLink = settings.emptyPrimaryLink || `${root()}collections/all`;
      const secondaryLink = settings.emptySecondaryLink || window.iiDealsUrl || `${root()}#deals`;
      content.innerHTML = `
        <div class="ii-cart__empty">
          <i data-lucide="shopping-cart" style="width:3rem;height:3rem;margin-bottom:1rem;opacity:0.2;"></i>
          <p>${escapeHtml(settings.emptyText || 'Your cart is empty.')}</p>
          <div class="ii-cart__empty-actions">
            <a class="ii-btn-primary" href="${escapeAttr(primaryLink)}">${escapeHtml(settings.emptyPrimaryText || 'Shop all products')}</a>
            <a class="ii-btn-secondary" href="${escapeAttr(secondaryLink)}" data-cart-empty-deals>${escapeHtml(settings.emptySecondaryText || 'View weekly deals')}</a>
          </div>
          ${renderEmptyCartTools()}
          ${renderRecentlyViewedCart(cart)}
        </div>
      `;
      initLucide(content);
      announceCart('Your cart is empty.');
      return;
    }

    const itemsHtml = cart.items.map((item, index) => `
      <div class="ii-cart__item" data-cart-line-index="${index}">
        ${item.image ? `<img src="${escapeAttr(item.image)}" alt="${escapeAttr(item.title)}" class="ii-cart__item-img">` : '<div class="ii-cart__item-img"></div>'}
        <div class="ii-cart__item-details">
          <a href="${escapeAttr(item.url)}" class="ii-cart__item-title">${escapeHtml(item.product_title)}</a>
          ${item.variant_title ? `<div class="ii-cart__item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
          ${item.sku ? `<div class="ii-cart__item-note">SKU ${escapeHtml(item.sku)}</div>` : ''}
          ${cartItemAlertsHtml(item)}
          <div class="ii-cart__item-actions">
            <div class="ii-cart__qty">
              <button type="button" class="ii-cart__qty-btn" data-cart-change="${escapeAttr(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
              <input class="ii-cart__qty-input" value="${item.quantity}" readonly aria-label="Quantity">
              <button type="button" class="ii-cart__qty-btn" data-cart-change="${escapeAttr(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <div class="ii-cart__line-price" style="display:flex;align-items:center;">
              ${Number(item.original_line_price || 0) > Number(item.final_line_price || 0) ? `<span class="ii-cart__item-original">${formatMoney(item.original_line_price)}</span>` : ''}
              <span class="ii-cart__item-price">${formatMoney(item.final_line_price)}</span>
              <button type="button" class="ii-cart__remove" data-cart-change="${escapeAttr(item.key)}" data-quantity="0">Remove</button>
            </div>
          </div>
          ${lineDiscountsHtml(item)}
        </div>
      </div>
    `).join('');

    content.innerHTML = `
      ${renderShippingBar(cart)}
      <div class="ii-cart__items">
        ${renderCartNotice()}
        ${itemsHtml}
        ${renderUpsells(cart)}
        ${renderCartRecommendationShell(cart)}
        ${renderRecentlyViewedCart(cart)}
        ${renderTrustBadges()}
      </div>
      <div class="ii-cart__footer">
        ${renderDiscountNotice()}
        ${renderCartSummary(cart)}
        <p class="ii-cart__taxes">Taxes and shipping calculated at checkout</p>
        <form action="${escapeAttr(root())}cart" method="post" class="ii-cart__checkout-form">
          <button type="submit" name="checkout" class="ii-btn-primary ii-cart__checkout">${escapeHtml(settings.checkoutText || 'CHECKOUT')} - ${formatMoney(cart.total_price)}</button>
        </form>
      </div>
      <div class="ii-cart__mobile-bar">
        <div class="ii-cart__mobile-bar-inner">
          <div class="ii-cart__mobile-total">
            <span>Subtotal</span>
            <strong>${formatMoney(cart.total_price)}</strong>
          </div>
          <form action="${escapeAttr(root())}cart" method="post">
            <button type="submit" name="checkout" class="ii-btn-primary ii-cart__checkout">${escapeHtml(settings.checkoutText || 'CHECKOUT')}</button>
          </form>
        </div>
      </div>
    `;
    initLucide(content);
    initCartRecommendations(cart);
    hydrateCartLineValidation(cart);
    announceCart(`Cart updated. ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in cart. Subtotal ${formatMoney(cart.total_price)}.`);
  }

  function fetchCart() {
    return fetch(root() + 'cart.js')
      .then((res) => res.json())
      .then((cart) => {
        updateCartCount(cart.item_count);
        renderCart(cart);
        return cart;
      })
      .catch(() => null);
  }

  function changeCartLine(key, quantity) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((body) => {
            throw new Error(body.description || body.message || labels().cartError || 'Quantity could not be updated.');
          });
        }
        return res.json();
      })
      .then((cart) => {
        updateCartCount(cart.item_count);
        renderCart(cart);
        return cart;
      });
  }

  function updateCartNote(note) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note })
    })
      .then((res) => {
        if (!res.ok) throw new Error(labels().cartError || 'Cart note could not be saved.');
        return res.json();
      })
      .catch(() => null);
  }

  function updateCartAttributes(attributes) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    })
      .then((res) => res.json())
      .then((cart) => {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(() => null);
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (cartProductCache.has(handle)) return cartProductCache.get(handle);
    const request = fetch(`${root()}products/${encodeURIComponent(handle)}.js`)
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
    cartProductCache.set(handle, request);
    return request;
  }

  function variantInventoryMessage(variant, quantity) {
    if (!variant) return '';
    if (variant.available === false) return 'This item is currently unavailable. Remove it or choose another option.';
    const inventoryQuantity = Number(variant.inventory_quantity);
    const tracksInventory = variant.inventory_management && variant.inventory_policy !== 'continue';
    if (tracksInventory && Number.isFinite(inventoryQuantity)) {
      if (inventoryQuantity <= 0) return 'This item is currently out of stock.';
      if (quantity > inventoryQuantity) return `Only ${inventoryQuantity} available. Lower the quantity before checkout.`;
      if (inventoryQuantity <= 3) return `Only ${inventoryQuantity} left in stock.`;
    }
    return '';
  }

  function hydrateCartLineValidation(cart) {
    const drawer = cartDrawer();
    if (!drawer || !cart || !Array.isArray(cart.items)) return;
    cart.items.forEach((item, index) => {
      fetchProductByHandle(item.handle).then((product) => {
        if (!product || !Array.isArray(product.variants)) return;
        const variant = product.variants.find((candidate) => Number(candidate.id) === Number(item.variant_id));
        const message = variantInventoryMessage(variant, Number(item.quantity || 0));
        const line = drawer.querySelector(`[data-cart-line-index="${index}"]`);
        if (!line) return;
        const priceWrap = line.querySelector('.ii-cart__line-price');
        if (priceWrap && variant && Number(variant.compare_at_price || 0) > Number(variant.price || 0)) {
          const compareTotal = Number(variant.compare_at_price || 0) * Number(item.quantity || 1);
          let original = priceWrap.querySelector('.ii-cart__item-original');
          if (!original) {
            original = document.createElement('span');
            original.className = 'ii-cart__item-original';
            priceWrap.insertBefore(original, priceWrap.firstChild);
          }
          original.textContent = formatMoney(compareTotal);
        }
        let alert = line.querySelector('[data-cart-line-alert]');
        if (message) {
          if (!alert) {
            alert = document.createElement('div');
            alert.className = 'ii-cart__item-alert';
            alert.setAttribute('data-cart-line-alert', '');
            line.querySelector('.ii-cart__item-details').appendChild(alert);
          }
          alert.innerHTML = `<i data-lucide="alert-triangle"></i>${escapeHtml(message)}`;
          if (variant && variant.available === false) {
            line.querySelectorAll('[data-cart-change]').forEach((button) => {
              if (button.getAttribute('data-quantity') !== '0') button.disabled = true;
            });
          }
          initLucide(line);
        } else if (alert) {
          alert.remove();
        }
      });
    });
  }

  function formItemPayload(form) {
    const formData = new FormData(form);
    const id = formData.get('id');
    const quantity = Number(formData.get('quantity') || 1);
    const properties = {};
    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    const item = { id: String(id), quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1 };
    if (Object.keys(properties).length > 0) item.properties = properties;
    return { items: [item] };
  }

  function showFormMessage(form, message, isError) {
    const target = form.querySelector('[data-form-message]') || form.querySelector('.ii-form-message');
    if (!target) return;
    target.textContent = message || '';
    target.classList.toggle('is-error', Boolean(isError));
  }

  function addItems(payload) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then((res) => {
      if (!res.ok) {
        return res.json().then((body) => {
          throw new Error(body.description || body.message || labels().cartError || 'Something went wrong. Please try again.');
        });
      }
      return res.json();
    }).then((response) => {
      const firstItem = payload && Array.isArray(payload.items) && payload.items[0];
      const variantId = firstItem && firstItem.id;
      if (variantId) storageSet('ii_last_added_variant_id', String(variantId));
      return response;
    });
  }

  function shouldAjaxForm(form) {
    if (!form || form.dataset.noAjaxCart === 'true') return false;
    const action = form.getAttribute('action') || '';
    return action.includes('/cart/add');
  }

  function setButtonState(button, text, disabled) {
    if (!button) return;
    button.innerHTML = text;
    button.disabled = Boolean(disabled);
  }

  function handleProductFormSubmit(event) {
    const form = event.target.closest('form');
    if (!shouldAjaxForm(form)) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const originalText = button ? button.innerHTML : '';
    showFormMessage(form, '', false);
    setButtonState(button, labels().adding || 'ADDING...', true);

    addItems(formItemPayload(form))
      .then(() => {
        setButtonState(button, labels().added || 'ADDED!', true);
        setTimeout(() => setButtonState(button, originalText, false), 1200);
        if (form.closest('.ii-qv-modal')) {
          closeAllModals();
        }
        openCart();
        track('add_to_cart', {});
      })
      .catch((error) => {
        setButtonState(button, originalText, false);
        showFormMessage(form, error.message || labels().cartError, true);
      });
  }

  function selectedOptions(form) {
    const options = [];
    form.querySelectorAll('[data-option-position]').forEach((input) => {
      const position = Number(input.getAttribute('data-option-position')) - 1;
      if (input.type === 'radio' && !input.checked) return;
      options[position] = input.value;
    });
    return options;
  }

  function variantsForForm(form) {
    const json = form.querySelector('[data-variant-json]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return [];
    }
  }

  function updateVariantForm(form) {
    const variants = variantsForForm(form);
    if (variants.length === 0) return;
    const options = selectedOptions(form);
    const variant = variants.find((candidate) => candidate.options && candidate.options.every((option, index) => option === options[index]));
    if (!variant) return;

    const hidden = form.querySelector('[data-variant-id], input[name="id"]');
    const button = form.querySelector('[data-atc-button], [type="submit"]');
    const scope = form.closest('[data-product-scope]') || form.closest('.ii-qv__info') || document;
    const price = scope.querySelector('[data-variant-price]');
    const compare = scope.querySelector('[data-variant-compare]');
    const save = scope.querySelector('[data-variant-save]');
    const stock = scope.querySelector('[data-stock-urgency]');
    const availability = scope.querySelector('[data-variant-availability]');
    const sku = scope.querySelector('[data-variant-sku]');
    const quickViewModal = form.closest('.ii-qv-modal');
    const mainImage = (quickViewModal && quickViewModal.querySelector('[data-qv-main-image], #ii-qv-main-image')) || scope.querySelector('[data-qv-main-image], #ii-qv-main-image') || document.getElementById('ii-main-product-image');

    if (hidden) {
      hidden.value = variant.id;
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (price) price.textContent = formatMoney(variant.price);
    document.querySelectorAll('[data-sticky-price]').forEach((el) => {
      el.textContent = formatMoney(variant.price);
    });
    if (compare) {
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !hasCompare;
      compare.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
    }
    if (save) {
      const hasSavings = variant.compare_at_price && variant.compare_at_price > variant.price;
      save.hidden = !hasSavings;
      save.textContent = hasSavings ? `${labels().save || 'SAVE'} ${Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)}%` : '';
    }
    if (stock) {
      const threshold = Number(stock.dataset.threshold || 10);
      const inventory = Number(variant.inventory_quantity || 0);
      const shouldShow = inventory > 0 && inventory <= threshold;
      stock.hidden = !shouldShow;
      stock.textContent = shouldShow ? `Only ${inventory} left` : '';
    }
    if (button) {
      button.disabled = !variant.available;
      button.innerHTML = variant.available ? (labels().atc || 'ADD TO CART') : (labels().soldOut || 'SOLD OUT');
    }
    if (availability) {
      availability.innerHTML = `<i data-lucide="${variant.available ? 'check-circle' : 'circle-off'}"></i> ${variant.available ? 'In stock' : 'Unavailable'}`;
      initLucide(availability);
    }
    if (sku) {
      const hasSku = Boolean(variant.sku);
      sku.hidden = !hasSku;
      sku.innerHTML = hasSku ? `<i data-lucide="barcode"></i> SKU ${escapeHtml(variant.sku)}` : '';
      initLucide(sku);
    }
    if (mainImage && variant.featured_image && variant.featured_image.src) {
      setImageSource(mainImage, variant.featured_image.src);
      const quickViewScope = mainImage.closest('.ii-qv__media');
      if (quickViewScope) {
        quickViewScope.querySelectorAll('[data-qv-image]').forEach((button) => {
          const imageUrl = button.getAttribute('data-qv-image') || '';
          button.classList.toggle('is-active', imageUrl === variant.featured_image.src || imageUrl.includes(variant.featured_image.src));
        });
      }
    }
  }

  function initVariantForms(scope) {
    const rootScope = scope || document;
    rootScope.querySelectorAll('form[data-product-form]').forEach(updateVariantForm);
  }

  function openQuickView(productUrl, trigger) {
    const modal = document.getElementById('ii-qv-modal');
    const content = document.getElementById('ii-qv-content');
    if (!modal || !content || !productUrl) return;
    quickViewReturnFocus = trigger || document.activeElement;
    content.innerHTML = '<div class="ii-qv__loading">Loading...</div>';
    modal.classList.add('is-open');
    showOverlay();
    const closeButton = modal.querySelector('[data-modal-close]');
    if (closeButton) closeButton.focus();

    const separator = productUrl.includes('?') ? '&' : '?';
    fetch(`${productUrl}${separator}section_id=ii-quick-view`)
      .then((res) => {
        if (!res.ok) throw new Error('Unable to load quick view.');
        return res.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newContent = doc.getElementById('ii-qv-content');
        if (!newContent) throw new Error('Quick view content was missing.');
        content.innerHTML = newContent.innerHTML;
        initLucide(content);
        initVariantForms(content);
      })
      .catch(() => {
        content.innerHTML = `<div class="ii-qv__loading">${escapeHtml(labels().cartError || 'Something went wrong. Please try again.')}</div>`;
      });
  }

  function normalizeStoredProduct(product) {
    const rawPrice = product && (product.priceValue != null ? product.priceValue : product.price);
    const numericPrice = Number(rawPrice);
    const rawCompareAtPrice = product && (product.compareAtPrice != null ? product.compareAtPrice : product.compare_at_price);
    const numericCompareAtPrice = Number(rawCompareAtPrice);
    const imageSource = product && (product.image || product.featured_image || product.featured_media);
    const image = typeof imageSource === 'string' ? imageSource : (imageSource && (imageSource.url || imageSource.src || imageSource.preview_image || ''));
    return {
      id: product && (product.id || product.productId || ''),
      variantId: product && (product.variantId || product.variant_id || (product.variants && product.variants[0] && product.variants[0].id) || ''),
      handle: product && (product.handle || ''),
      title: product && (product.title || ''),
      url: product && (product.url || '#'),
      image,
      price: Number.isFinite(numericPrice) ? numericPrice : rawPrice,
      priceText: Number.isFinite(numericPrice) ? formatMoney(numericPrice) : escapeHtml(rawPrice || ''),
      compareAtPrice: Number.isFinite(numericCompareAtPrice) ? numericCompareAtPrice : rawCompareAtPrice
    };
  }

  function recentProducts() {
    return storageArray(RECENT_KEY).filter((item) => item && item.handle);
  }

  function saveRecentProducts(products) {
    saveStorageArray(RECENT_KEY, products.slice(0, 20));
  }

  function cacheRecentVariant(handle, productData) {
    const variants = Array.isArray(productData && productData.variants) ? productData.variants : [];
    const firstAvailableVariant = variants.find((variant) => variant && variant.available !== false) || variants[0];
    if (!handle || !firstAvailableVariant || !firstAvailableVariant.id) return firstAvailableVariant;
    const recent = recentProducts().map((product) => {
      if (!product || product.handle !== handle) return product;
      return Object.assign({}, product, {
        variantId: firstAvailableVariant.id,
        available: productData.available !== false,
        variants: variants.map((variant) => ({
          id: variant.id,
          available: variant.available !== false
        }))
      });
    });
    saveRecentProducts(recent);
    return firstAvailableVariant;
  }

  function renderUtilityItem(product) {
    const item = normalizeStoredProduct(product);
    return `
      <div class="ii-utility-item" data-utility-item="${escapeAttr(item.handle)}">
        ${item.image ? `<img class="ii-utility-item__img" src="${escapeAttr(item.image)}" alt="${escapeAttr(item.title)}" loading="lazy">` : '<div class="ii-utility-item__img"></div>'}
        <div>
          <a href="${escapeAttr(item.url)}" class="ii-utility-item__title">${escapeHtml(item.title)}</a>
          ${item.priceText ? `<div class="ii-utility-item__price">${item.priceText}</div>` : ''}
        </div>
        <a href="${escapeAttr(item.url)}" class="ii-utility-item__remove" aria-label="View ${escapeAttr(item.title)}"><i data-lucide="arrow-up-right"></i></a>
      </div>
    `;
  }

  function renderUtilityPanel() {
    const recentPane = document.querySelector('[data-utility-pane="recent"]');
    const recentItems = recentProducts();

    if (recentPane) {
      recentPane.innerHTML = recentItems.length
        ? recentItems.slice(0, 10).map((item) => renderUtilityItem(item)).join('')
        : '<div class="ii-utility-empty"><strong>No recently viewed products yet</strong><br>Browse a product and it will appear here.</div>';
    }
    initLucide(document.getElementById('ii-utility-panel') || document);
  }

  function openUtilityPanel() {
    const panel = document.getElementById('ii-utility-panel');
    if (!panel) return;
    renderUtilityPanel();
    const title = document.getElementById('ii-utility-title');
    if (title) title.textContent = 'Recently Viewed';
    panel.classList.add('is-open');
    showOverlay();
    const closeButton = panel.querySelector('[data-modal-close]');
    if (closeButton) closeButton.focus();
  }

  function renderProductCard(product) {
    const item = normalizeStoredProduct(product);
    const url = item.url || '#';
    const title = item.title || '';
    const imageSource = item.image || product.featured_image;
    const image = typeof imageSource === 'string' ? imageSource : (imageSource && (imageSource.url || imageSource.src));
    const compareAtPrice = Number(item.compareAtPrice || 0);
    const currentPrice = Number(item.price || 0);
    const hasSavings = compareAtPrice > currentPrice;
    const savingsPercent = hasSavings ? Math.round(((compareAtPrice - currentPrice) * 100) / compareAtPrice) : 0;
    const available = product.available !== false;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const firstAvailableVariant = variants.find((variant) => variant && variant.available !== false) || variants[0];
    const variantId = item.variantId || (firstAvailableVariant && firstAvailableVariant.id);
    const metaLabel = product.metaLabel || 'Recently viewed';
    const atcHtml = variantId && variants.length <= 1
      ? `
        <div class="ii-product-card__atc-wrapper">
          <form action="${escapeAttr(root())}cart/add" method="post">
            <input type="hidden" name="id" value="${escapeAttr(variantId)}">
            <button type="submit" class="ii-btn-primary ii-product-card__atc" ${available ? '' : 'disabled'}>${escapeHtml(available ? (labels().atc || 'ADD TO CART') : (labels().soldOut || 'SOLD OUT'))}</button>
          </form>
        </div>
      `
      : `
        <div class="ii-product-card__atc-wrapper">
          <a href="${escapeAttr(url)}" class="ii-btn-primary ii-product-card__atc">${escapeHtml(labels().chooseFormat || 'CHOOSE FORMAT')}</a>
        </div>
      `;
    const priceHtml = hasSavings
      ? `
        <div class="ii-product-card__price ii-product-card__price--sale">
          <span class="ii-product-card__price-group"><span class="ii-product-card__price-label">Before</span><del class="ii-product-card__compare">${formatMoney(compareAtPrice)}</del></span>
          <span class="ii-product-card__price-group"><span class="ii-product-card__price-label">Now</span><span class="ii-product-card__current">${formatMoney(currentPrice)}</span></span>
        </div>
        <div class="ii-product-card__savings">You save ${savingsPercent}%</div>
      `
      : `
        <div class="ii-product-card__price">
          <span class="ii-product-card__price-group"><span class="ii-product-card__price-label">Price</span><span class="ii-product-card__current">${item.priceText}</span></span>
        </div>
      `;
    return `
      <div class="ii-product-card ii-card" data-product-card data-product-handle="${escapeAttr(item.handle)}" data-product-id="${escapeAttr(item.id)}">
        <a href="${escapeAttr(url)}" class="ii-product-card__link">
          <div class="ii-product-card__image-wrapper">
            ${image ? `<img src="${escapeAttr(image)}" alt="${escapeAttr(title)}" loading="lazy">` : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#222;color:#666;">No Image</div>'}
          </div>
          ${product.vendor ? `<div class="ii-product-card__vendor">${escapeHtml(product.vendor)}</div>` : '<div class="ii-product-card__vendor"></div>'}
          <h3 class="ii-product-card__title">${escapeHtml(title)}</h3>
          ${priceHtml}
          <div class="ii-product-card__meta"><span><i data-lucide="check-circle"></i>${escapeHtml(metaLabel)}</span></div>
        </a>
        <button type="button" class="ii-btn-secondary ii-product-card__quick-view" data-quick-view="${escapeAttr(url)}" aria-label="Quick view ${escapeAttr(title)}"><i data-lucide="eye"></i> Quick View</button>
        ${atcHtml}
      </div>
    `;
  }

  function initRecentlyViewed(scope) {
    const current = window.iiCurrentProduct;
    let recent = recentProducts();

    if (current && current.handle) {
      recent = recent.filter((item) => item && item.handle !== current.handle);
      recent.unshift(current);
      recent = recent.slice(0, 20);
      saveRecentProducts(recent);
    }

    (scope || document).querySelectorAll('.ii-recently-viewed-section').forEach((section) => {
      const grid = section.querySelector('[data-recent-grid]');
      if (!grid) return;
      const limit = Number(section.dataset.limit || 6);
      const products = recent.filter((item) => item && (!current || item.handle !== current.handle)).slice(0, limit);
      if (products.length === 0) {
        section.style.display = 'none';
        return;
      }
      grid.innerHTML = products.map(renderProductCard).join('');
      section.style.display = '';
      initLucide(section);
    });
    renderUtilityPanel();
  }

  function initRecommendations(scope) {
    (scope || document).querySelectorAll('[data-product-recommendations]').forEach((container) => {
      if (container.dataset.iiLoaded) return;
      container.dataset.iiLoaded = 'true';
      const productId = container.dataset.productId;
      const limit = container.dataset.limit || 8;
      const intent = container.dataset.recommendationIntent || 'complementary';
      if (!productId) return;
      fetchProductRecommendations(productId, limit, [intent, 'related'])
        .then((products) => {
          if (products.length > 0) {
            container.innerHTML = products.map((product) => {
              const label = product._iiRecommendationIntent === 'complementary' ? 'Pairs well' : 'Recommended';
              return renderProductCard(normalizeRecommendationProduct(product, label));
            }).join('');
            initLucide(container);
            return;
          }
          const fallback = container.parentElement && container.parentElement.querySelector('[data-recommendation-fallback]');
          if (fallback) {
            container.innerHTML = fallback.innerHTML;
            initLucide(container);
          }
        })
        .catch(() => {
          const fallback = container.parentElement && container.parentElement.querySelector('[data-recommendation-fallback]');
          if (fallback) {
            container.innerHTML = fallback.innerHTML;
            initLucide(container);
          }
        });
    });
  }

  function initPredictiveSearch(scope) {
    const rootScope = scope || document;
    renderSearchHistory(rootScope);

    rootScope.querySelectorAll('[data-search-input], #ii-search-input, #ii-header-search-input').forEach((input) => {
      if (input.dataset.iiSearchBound) return;
      input.dataset.iiSearchBound = 'true';
      const box = input.parentElement && input.parentElement.querySelector('.ii-predictive-box');
      if (!box) return;
      let controller;
      let activeIndex = -1;

      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      if (box.id) input.setAttribute('aria-controls', box.id);
      box.setAttribute('role', 'listbox');

      function setOpen(isOpen) {
        box.setAttribute('data-empty', String(!isOpen));
        input.setAttribute('aria-expanded', String(Boolean(isOpen)));
        if (!isOpen) {
          activeIndex = -1;
          input.removeAttribute('aria-activedescendant');
        }
      }

      function resourceUrl(query) {
        const params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'query,product,collection,page,article');
        params.set('resources[limit]', '5');
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,vendor,variants.title,variants.sku,tag,body');
        return `${root()}search/suggest.json?${params.toString()}`;
      }

      function resultImage(item) {
        const source = item && (item.image || item.featured_image || item.featured_media);
        if (!source) return '';
        if (typeof source === 'string') return source;
        return source.url || source.src || source.preview_image || '';
      }

      function querySuggestionText(item) {
        return item.text || item.query || item.title || item.styled_text || '';
      }

      function querySuggestionUrl(item) {
        const text = querySuggestionText(item);
        return item.url || `${root()}search?q=${encodeURIComponent(text)}&type=product%2Carticle%2Cpage&options%5Bprefix%5D=last`;
      }

      function searchUrl(query, type) {
        return `${root()}search?q=${encodeURIComponent(query || '')}&type=${type || 'product%2Carticle%2Cpage'}&options%5Bprefix%5D=last`;
      }

      function optionAttrs(kind, label) {
        return `role="option" tabindex="-1" data-predictive-option data-search-track="${escapeAttr(kind)}" data-search-label="${escapeAttr(label)}"`;
      }

      function chipsHtml(title, items, kind) {
        if (!items || items.length === 0) return '';
        return `
          <div class="ii-predictive__section">
            <div class="ii-predictive__heading">${escapeHtml(title)}</div>
            <div class="ii-predictive__chips">
              ${items.map((item) => {
                const href = typeof item.url === 'function' ? item.url() : (item.url || searchUrl(item.query || item.label || ''));
                return `<a class="ii-predictive__chip" href="${escapeAttr(href)}" ${optionAttrs(kind, item.label)}><i data-lucide="${escapeAttr(item.icon || 'search')}"></i>${escapeHtml(item.label)}</a>`;
              }).join('')}
            </div>
          </div>
        `;
      }

      function itemCard(item, type) {
        const image = resultImage(item);
        const url = item.url || '#';
        const title = item.title || querySuggestionText(item);
        const price = typeof item.price === 'number' ? formatMoney(item.price) : item.price;
        const compareAt = item.compare_at_price || item.compareAtPrice || item.compare_at_price_min || item.compare_at_price_max;
        const compareAtPrice = typeof compareAt === 'number' ? formatMoney(compareAt) : compareAt;
        const hasDiscount = type === 'product' && compareAt && price && Number(compareAt) > Number(item.price);
        const available = item.available === true || item.available_for_sale === true;
        const variantSku = item.variants && item.variants.length ? item.variants.find((variant) => variant && variant.sku) : null;
        const sku = item.sku || item.variant_sku || (variantSku && variantSku.sku);
        const meta = type === 'product'
          ? [item.vendor, item.product_type, typeof item.price === 'number' ? formatMoney(item.price) : item.price].filter(Boolean).join(' · ')
          : (item.blog_title || item.author || item.handle || '');
        const displayMeta = type === 'product' ? [item.vendor, item.product_type].filter(Boolean).join(' · ') : meta;
        const displayMetaAscii = type === 'product' ? [item.vendor, item.product_type].filter(Boolean).join(' / ') : displayMeta;
        return `
          <a class="ii-predictive__item" href="${escapeAttr(url)}" ${optionAttrs(type, title)}>
            ${image ? `<img class="ii-predictive__image" src="${escapeAttr(image)}" alt="${escapeAttr(title)}">` : `<span class="ii-predictive__icon"><i data-lucide="${type === 'collection' ? 'layers' : type === 'article' ? 'newspaper' : type === 'page' ? 'file-text' : 'search'}"></i></span>`}
            <span class="ii-predictive__copy">
              <span class="ii-predictive__title">${escapeHtml(title)}</span>
              ${displayMetaAscii ? `<span class="ii-predictive__meta">${escapeHtml(displayMetaAscii)}</span>` : ''}
              ${type === 'product' ? `<span class="ii-predictive__meta" data-predictive-sku data-product-url="${escapeAttr(url)}">${sku ? `SKU ${escapeHtml(sku)}` : ''}</span>` : ''}
              ${type === 'product' && available ? '<span class="ii-predictive__stock">In stock</span>' : ''}
            </span>
            ${type === 'product' && price ? `<span class="ii-predictive__price">${hasDiscount ? `<del class="ii-predictive__compare">${escapeHtml(compareAtPrice)}</del>` : ''}<span class="ii-predictive__current">${escapeHtml(price)}</span></span>` : ''}
          </a>
        `;
      }

      function productJsonUrl(url) {
        try {
          const parsed = new URL(url, window.location.origin);
          parsed.search = '';
          parsed.hash = '';
          if (!parsed.pathname.endsWith('.js')) parsed.pathname = `${parsed.pathname.replace(/\/$/, '')}.js`;
          return parsed.toString();
        } catch (error) {
          return '';
        }
      }

      function hydratePredictiveSkus(container) {
        container.querySelectorAll('[data-predictive-sku]').forEach((slot) => {
          if (slot.textContent.trim() || slot.dataset.skuHydrated) return;
          const url = productJsonUrl(slot.getAttribute('data-product-url') || '');
          if (!url) return;
          slot.dataset.skuHydrated = 'true';
          fetch(url)
            .then((res) => (res.ok ? res.json() : null))
            .then((product) => {
              const variant = product && product.variants && product.variants.find((item) => item && item.sku);
              if (variant && variant.sku) slot.textContent = `SKU ${variant.sku}`;
            })
            .catch(() => {});
        });
      }

      function sectionHtml(title, items, type) {
        if (!items || items.length === 0) return '';
        return `
          <div class="ii-predictive__section">
            <div class="ii-predictive__heading">${escapeHtml(title)}</div>
            <div class="ii-predictive__list">
              ${items.map((item) => type === 'query'
                ? `<a class="ii-predictive__query" href="${escapeAttr(querySuggestionUrl(item))}" ${optionAttrs('query', querySuggestionText(item))}><i data-lucide="corner-down-right"></i>${escapeHtml(querySuggestionText(item))}</a>`
                : itemCard(item, type)
              ).join('')}
            </div>
          </div>
        `;
      }

      function refreshOptions() {
        const options = Array.from(box.querySelectorAll('[data-predictive-option], .ii-predictive__all'));
        options.forEach((option, index) => {
          if (!option.id) option.id = `${box.id || 'ii-predictive-option'}-${index}`;
          option.classList.toggle('is-active', index === activeIndex);
        });
        if (activeIndex >= 0 && options[activeIndex]) input.setAttribute('aria-activedescendant', options[activeIndex].id);
        else input.removeAttribute('aria-activedescendant');
        return options;
      }

      function renderStarter() {
        const history = searchHistory().map((term) => ({ label: term, query: term, icon: 'history' }));
        box.classList.remove('is-loading');
        box.innerHTML = `
          <div class="ii-predictive__inner ii-predictive__starter">
            ${chipsHtml('Recent searches', history, 'recent')}
            ${chipsHtml('Popular searches', POPULAR_SEARCHES, 'popular')}
            ${chipsHtml('Search shortcuts', SEARCH_SHORTCUTS, 'shortcut')}
          </div>
        `;
        setOpen(true);
        activeIndex = -1;
        refreshOptions();
        initLucide(box);
        hydratePredictiveSkus(box);
      }

      function renderLoading(query) {
        box.classList.add('is-loading');
        box.innerHTML = `
          <div class="ii-predictive__loading">
            <strong>Searching "${escapeHtml(query)}"</strong>
            <span>Finding products, guides, and pages.</span>
          </div>
        `;
        setOpen(true);
      }

      function renderResults(data, query) {
        box.classList.remove('is-loading');
        const results = data && data.resources && data.resources.results ? data.resources.results : {};
        const html = [
          sectionHtml('Products', results.products || [], 'product'),
          sectionHtml('Suggested searches', results.queries || [], 'query'),
          sectionHtml('Collections', results.collections || [], 'collection'),
          sectionHtml('Guides', results.articles || [], 'article'),
          sectionHtml('Pages', results.pages || [], 'page')
        ].join('');

        if (!html) {
          box.innerHTML = `
            <div class="ii-predictive__empty">
              <strong>No quick matches</strong>
              <span>Press Enter to search the whole store, or try a shorter keyword.</span>
            </div>
          `;
          track('predictive_search_no_results', { search_term: query });
          setOpen(true);
          return;
        }

        box.innerHTML = `
          <div class="ii-predictive__inner">
            ${chipsHtml('Refine search', [
              { label: 'Products', icon: 'shopping-bag', url: searchUrl(query, 'product') },
              { label: 'Guides', icon: 'newspaper', url: searchUrl(query, 'article%2Cpage') }
            ], 'shortcut')}
            ${html}
            <a class="ii-predictive__all" href="${searchUrl(query)}" data-predictive-option data-search-track="all-results" data-search-label="${escapeAttr(query)}">
              View all results for "${escapeHtml(query)}"
              <i data-lucide="arrow-right"></i>
            </a>
          </div>
        `;
        setOpen(true);
        activeIndex = -1;
        refreshOptions();
        initLucide(box);
        hydratePredictiveSkus(box);
      }

      function renderError(query) {
        box.classList.remove('is-loading');
        box.innerHTML = `
          <div class="ii-predictive__empty">
            <strong>Search suggestions are unavailable</strong>
            <span>Press Enter to search all results for "${escapeHtml(query)}".</span>
          </div>
        `;
        setOpen(true);
      }

      input.addEventListener('focus', () => {
        if (input.value.trim().length < 2) renderStarter();
        else if (box.innerHTML.trim()) setOpen(true);
      });

      input.addEventListener('input', () => {
        const query = input.value.trim();
        const cacheKey = query.toLowerCase();
        if (controller) controller.abort();
        if (query.length < 2) {
          renderStarter();
          return;
        }
        if (predictiveCache.has(cacheKey)) {
          renderResults(predictiveCache.get(cacheKey), query);
          return;
        }
        renderLoading(query);
        controller = new AbortController();
        const signal = controller.signal;
        fetch(resourceUrl(query), { signal })
          .then((res) => res.json())
          .then((data) => {
            if (signal.aborted) return;
            predictiveCache.set(cacheKey, data);
            renderResults(data, query);
          })
          .catch(() => {
            if (signal.aborted) return;
            renderError(query);
          });
      });

      input.addEventListener('keydown', (event) => {
        const options = refreshOptions();
        if (event.key === 'Escape') {
          setOpen(false);
          return;
        }
        if (options.length === 0) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activeIndex = Math.min(activeIndex + 1, options.length - 1);
          refreshOptions();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          refreshOptions();
        } else if (event.key === 'Enter' && activeIndex >= 0 && options[activeIndex]) {
          event.preventDefault();
          options[activeIndex].click();
        }
      });

      box.addEventListener('mousedown', (event) => {
        event.preventDefault();
      });

      box.addEventListener('click', (event) => {
        const target = event.target.closest('[data-search-track]');
        if (!target) return;
        track('predictive_search_click', {
          result_type: target.getAttribute('data-search-track'),
          search_term: input.value.trim(),
          result_label: target.getAttribute('data-search-label') || target.textContent.trim()
        });
      });
    });
  }

  function searchHistory() {
    try {
      return JSON.parse(storageGet('ii_search_history') || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveSearchTerm(term) {
    const cleaned = String(term || '').trim();
    if (!cleaned) return;
    const next = [cleaned, ...searchHistory().filter((item) => item.toLowerCase() !== cleaned.toLowerCase())].slice(0, 6);
    storageSet('ii_search_history', JSON.stringify(next));
  }

  function renderSearchHistory(scope) {
    (scope || document).querySelectorAll('[data-search-history]').forEach((container) => {
      const history = searchHistory();
      if (history.length === 0) {
        container.setAttribute('data-empty', 'true');
        container.innerHTML = '';
        return;
      }
      container.setAttribute('data-empty', 'false');
      container.innerHTML = `
        <div class="ii-search__quick" aria-label="Recent searches">
          <span style="color:#888;font-size:0.875rem;align-self:center;">Recent:</span>
          ${history.map((term) => `<a class="ii-search__chip" href="${root()}search?q=${encodeURIComponent(term)}&type=product%2Carticle%2Cpage&options%5Bprefix%5D=last"><i data-lucide="history"></i>${escapeHtml(term)}</a>`).join('')}
          <button type="button" class="ii-search__chip" data-search-history-clear><i data-lucide="trash-2"></i>Clear</button>
        </div>
      `;
      initLucide(container);
    });
  }

  function initAnnouncements(scope) {
    (scope || document).querySelectorAll('[data-announcement]').forEach((bar) => {
      const key = bar.getAttribute('data-announcement-key');
      if (key && storageGet(key) === 'hidden') {
        bar.hidden = true;
      }
    });
  }

  function initCollectionTools(scope) {
    (scope || document).querySelectorAll('[data-collection-grid]').forEach((grid) => {
      const storageKey = grid.getAttribute('data-view-storage') || 'ii_collection_view';
      const defaultMode = grid.getAttribute('data-default-view') === 'list' ? 'list' : 'grid';
      const persistView = grid.getAttribute('data-persist-view') !== 'false';
      const storedMode = persistView ? storageGet(storageKey) : null;
      const mode = storedMode === 'list' || storedMode === 'grid' ? storedMode : defaultMode;
      const viewScope = grid.closest('[id^="ii-"], main, section') || document;
      grid.classList.toggle('is-list', mode === 'list');
      viewScope.querySelectorAll('[data-view-mode]').forEach((button) => {
        const active = button.getAttribute('data-view-mode') === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    });
  }

  function initCountdowns(scope) {
    (scope || document).querySelectorAll('[data-countdown]').forEach((countdown) => {
      if (countdown.dataset.iiCountdownBound) return;
      countdown.dataset.iiCountdownBound = 'true';
      const target = new Date(countdown.getAttribute('data-countdown')).getTime();
      if (!Number.isFinite(target)) return;
      const parts = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      };
      const pad = (value) => String(value).padStart(2, '0');
      const tick = () => {
        const distance = target - Date.now();
        if (distance <= 0) {
          countdown.innerHTML = `<span class="ii-deals-bar__time"><span class="ii-deals-bar__num">${escapeHtml(countdown.getAttribute('data-expired-text') || labels().expired || 'EXPIRED')}</span></span>`;
          clearInterval(timer);
          return;
        }
        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);
        if (parts.days) parts.days.textContent = pad(days);
        if (parts.hours) parts.hours.textContent = pad(hours);
        if (parts.minutes) parts.minutes.textContent = pad(minutes);
        if (parts.seconds) parts.seconds.textContent = pad(seconds);
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  }

  function initProductMarquees(scope) {
    (scope || document).querySelectorAll('[data-product-marquee]').forEach((marquee) => {
      if (marquee.dataset.iiMarqueeBound) return;
      marquee.dataset.iiMarqueeBound = 'true';

      const shell = marquee.closest('.ii-product-marquee-shell') || marquee.parentElement;
      const track = marquee.querySelector('[data-marquee-track]');
      const prev = shell && shell.querySelector('[data-marquee-prev]');
      const next = shell && shell.querySelector('[data-marquee-next]');
      const toggle = shell && shell.querySelector('[data-marquee-toggle]');
      let pausedByControl = false;
      let pausedByHover = false;
      let pausedByInteraction = false;
      let pausedByFocus = false;
      let visible = true;
      let dragging = false;
      let dragged = false;
      let suppressClick = false;
      let capturedPointerId = null;
      let resumeTimer;
      let touchScrollTimer;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let scrollPosition = marquee.scrollLeft;
      let internalScrollWrite = false;
      let touchInteracting = false;
      let touchSettling = false;
      let lastTime = performance.now();
      const secondsPerLoop = Math.max(25, Number(marquee.getAttribute('data-speed')) || 55);

      marquee.querySelectorAll('[aria-hidden="true"] a, [aria-hidden="true"] button, [aria-hidden="true"] input, [aria-hidden="true"] select, [aria-hidden="true"] textarea, [aria-hidden="true"] [tabindex]').forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });

      const loopDistance = () => {
        if (!track) return 0;
        const secondCopy = track.querySelector('[data-marquee-copy="2"]');
        return secondCopy ? Math.max(secondCopy.offsetLeft, 0) : Math.max(track.scrollWidth / 2, 0);
      };
      const makeHidden = (root) => {
        root.setAttribute('aria-hidden', 'true');
        root.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
      };
      const ensureLoopCoverage = () => {
        if (!track) return;
        const originals = Array.from(track.querySelectorAll('[data-marquee-copy="1"]'));
        let distance = loopDistance();
        let guard = 0;
        while (originals.length && distance && track.scrollWidth < distance + marquee.clientWidth && guard < 8) {
          originals.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-marquee-copy', 'extra');
            makeHidden(clone);
            track.appendChild(clone);
          });
          distance = loopDistance();
          guard += 1;
        }
      };
      const canLoop = () => {
        const distance = loopDistance();
        return Boolean(distance && track && track.scrollWidth >= distance + marquee.clientWidth);
      };
      const stepSize = () => Math.max(marquee.clientWidth * 0.75, 260);
      const normalize = (position = scrollPosition) => {
        const distance = loopDistance();
        if (!distance) return position;
        let nextPosition = position;
        while (nextPosition >= distance) nextPosition -= distance;
        while (nextPosition < 0) nextPosition += distance;
        scrollPosition = nextPosition;
        if (Math.abs(marquee.scrollLeft - nextPosition) > 0.01) {
          internalScrollWrite = true;
          marquee.scrollLeft = nextPosition;
          window.requestAnimationFrame(() => {
            internalScrollWrite = false;
          });
        }
        return nextPosition;
      };
      const updateToggle = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', String(pausedByControl));
        toggle.setAttribute('aria-label', pausedByControl ? 'Play product row' : 'Pause product row');
        toggle.innerHTML = pausedByControl ? '<i data-lucide="play"></i>' : '<i data-lucide="pause"></i>';
        initLucide(toggle);
      };
      const pauseBriefly = () => {
        if (pausedByControl) return;
        pausedByInteraction = true;
        clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          pausedByInteraction = false;
        }, 1400);
      };
      const scrollByAmount = (amount) => {
        pauseBriefly();
        marquee.scrollBy({ left: amount, behavior: 'smooth' });
        window.setTimeout(normalize, 420);
      };
      const finishTouchScroll = () => {
        touchInteracting = false;
        touchSettling = false;
        normalize(marquee.scrollLeft);
        pauseBriefly();
        if (suppressClick) {
          window.setTimeout(() => {
            dragged = false;
            suppressClick = false;
          }, 350);
        }
      };
      const scheduleTouchSettle = () => {
        touchSettling = true;
        clearTimeout(touchScrollTimer);
        touchScrollTimer = window.setTimeout(finishTouchScroll, 180);
      };
      const tick = (time) => {
        const delta = Math.min(time - lastTime, 64);
        lastTime = time;
        if (visible && !pausedByControl && !pausedByHover && !pausedByInteraction && !pausedByFocus && !dragging && canLoop()) {
          const pixelsPerSecond = Math.max(loopDistance(), marquee.clientWidth) / secondsPerLoop;
          scrollPosition = normalize(scrollPosition + (pixelsPerSecond * delta) / 1000);
        }
        window.requestAnimationFrame(tick);
      };

      marquee.addEventListener('pointerenter', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(resumeTimer);
        pausedByHover = true;
      });
      marquee.addEventListener('pointerleave', () => {
        pausedByHover = false;
        dragging = false;
        marquee.classList.remove('is-dragging');
      });
      marquee.addEventListener('focusin', () => {
        pausedByFocus = true;
      });
      marquee.addEventListener('focusout', () => {
        if (!marquee.contains(document.activeElement)) pausedByFocus = false;
      });
      marquee.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary')) return;
        clearTimeout(resumeTimer);
        dragged = false;
        suppressClick = false;
        capturedPointerId = null;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = marquee.scrollLeft;
        scrollPosition = startScrollLeft;
        if (event.pointerType === 'touch') {
          touchInteracting = true;
          touchSettling = false;
          pausedByInteraction = true;
          clearTimeout(touchScrollTimer);
          return;
        }
        dragging = true;
      });
      marquee.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') {
          if (!touchInteracting) return;
          const distanceX = event.clientX - startX;
          const distanceY = event.clientY - startY;
          if (Math.abs(distanceX) > 10 && Math.abs(distanceX) > Math.abs(distanceY)) {
            dragged = true;
            suppressClick = true;
          }
          return;
        }
        if (!dragging) return;
        const distanceX = event.clientX - startX;
        const distanceY = event.clientY - startY;
        if (!dragged) {
          if (Math.abs(distanceX) < 8 && Math.abs(distanceY) < 8) return;
          if (event.pointerType === 'touch' && Math.abs(distanceY) > Math.abs(distanceX)) {
            dragging = false;
            return;
          }
          dragged = true;
          suppressClick = true;
          capturedPointerId = event.pointerId;
          if (marquee.setPointerCapture) marquee.setPointerCapture(event.pointerId);
        }
        marquee.classList.add('is-dragging');
        scrollPosition = normalize(startScrollLeft - distanceX);
        event.preventDefault();
      });
      marquee.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'touch') {
          touchInteracting = false;
          if (dragged || Math.abs(marquee.scrollLeft - startScrollLeft) > 6) {
            scheduleTouchSettle();
          } else {
            pausedByInteraction = false;
          }
          return;
        }
        dragging = false;
        marquee.classList.remove('is-dragging');
        if (capturedPointerId !== null && marquee.releasePointerCapture && marquee.hasPointerCapture && marquee.hasPointerCapture(event.pointerId)) {
          marquee.releasePointerCapture(event.pointerId);
        }
        if (dragged) {
          pauseBriefly();
          window.setTimeout(() => {
            dragged = false;
            suppressClick = false;
            capturedPointerId = null;
          }, 350);
        }
      });
      marquee.addEventListener('pointercancel', () => {
        if (touchInteracting) {
          touchInteracting = false;
          scheduleTouchSettle();
          return;
        }
        dragging = false;
        dragged = false;
        suppressClick = false;
        capturedPointerId = null;
        marquee.classList.remove('is-dragging');
      });
      marquee.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
        suppressClick = false;
        capturedPointerId = null;
      }, true);
      marquee.addEventListener('scroll', () => {
        if (internalScrollWrite && !dragging) return;
        if (touchInteracting || touchSettling) {
          scrollPosition = marquee.scrollLeft;
          if (Math.abs(scrollPosition - startScrollLeft) > 6) {
            dragged = true;
            suppressClick = true;
          }
          scheduleTouchSettle();
          return;
        }
        scrollPosition = normalize(marquee.scrollLeft);
      }, { passive: true });

      if (prev) {
        prev.addEventListener('click', () => scrollByAmount(-stepSize()));
      }
      if (next) {
        next.addEventListener('click', () => scrollByAmount(stepSize()));
      }
      if (toggle) {
        toggle.addEventListener('click', () => {
          pausedByControl = !pausedByControl;
          clearTimeout(resumeTimer);
          pausedByInteraction = false;
          updateToggle();
        });
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.isIntersecting);
        }, { threshold: 0.01 });
        observer.observe(marquee);
      }
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(ensureLoopCoverage);
        resizeObserver.observe(marquee);
      } else {
        window.addEventListener('resize', ensureLoopCoverage, { passive: true });
      }

      ensureLoopCoverage();
      updateToggle();
      window.requestAnimationFrame(tick);
    });
  }

  function updateReadingProgress() {
    const bar = document.querySelector('[data-reading-progress]');
    if (!bar) return;
    const article = document.querySelector('.ii-article__content');
    if (!article) {
      bar.style.width = '0';
      return;
    }
    const rect = article.getBoundingClientRect();
    const total = Math.max(article.offsetHeight - window.innerHeight * 0.35, 1);
    const read = Math.min(Math.max(window.innerHeight * 0.2 - rect.top, 0), total);
    bar.style.width = `${(read / total) * 100}%`;
  }

  function updateBackToTop() {
    document.querySelectorAll('[data-back-to-top]').forEach((button) => {
      button.hidden = window.scrollY < 500;
    });
  }

  function initPageUtilities() {
    if (!window.iiUtilitiesBound) {
      window.iiUtilitiesBound = true;
      window.addEventListener('scroll', () => {
        updateReadingProgress();
        updateBackToTop();
      }, { passive: true });
      window.addEventListener('resize', updateReadingProgress);
    }
    updateReadingProgress();
    updateBackToTop();
  }

  function track(eventName, payload) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload || {});
    }
  }

  function initAll(scope) {
    initLucide(scope || document.body);
    initMobileMenu(scope || document);
    initMegaMenus(scope || document);
    initAccordions(scope || document);
    initSubcollectionModals(scope || document);
    initVariantForms(scope || document);
    initRecentlyViewed(scope || document);
    initRecommendations(scope || document);
    initPredictiveSearch(scope || document);
    initAnnouncements(scope || document);
    initCollectionTools(scope || document);
    initCountdowns(scope || document);
    initProductMarquees(scope || document);
    initPageUtilities();
    renderUtilityPanel();
  }

  window.iiInitAccordions = initAccordions;
  window.iiInitSearch = initPredictiveSearch;
  window.iiInitMegaMenu = (scope) => {
    initMobileMenu(scope || document);
    initMegaMenus(scope || document);
  };
  window.iiInitShippingBar = fetchCart;

  document.addEventListener('DOMContentLoaded', () => {
    initAll(document);
    fetchCart();
    if (window.iiCurrentProduct && !window.iiViewedItemTracked) {
      window.iiViewedItemTracked = true;
      track('view_item', {
        items: [{
          item_id: window.iiCurrentProduct.handle,
          item_name: window.iiCurrentProduct.title,
          price: window.iiCurrentProduct.price
        }]
      });
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('submit', handleProductFormSubmit);
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.ii-cart__checkout-form, #ii-cart-page-form');
    if (!form) return;
    const submitter = event.submitter;
    const isCheckout = submitter && submitter.getAttribute('name') === 'checkout';
    if (!isCheckout) return;
    track('begin_checkout', {});
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-confirm-message]');
    if (!form) return;
    const message = form.getAttribute('data-confirm-message') || 'Are you sure?';
    if (!window.confirm(message)) event.preventDefault();
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-validate-form]');
    if (!form) return;
    if (!validateAccountForm(form)) event.preventDefault();
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-search-form], .ii-header__search-form, .ii-search__form');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (input) {
      saveSearchTerm(input.value);
      track('search_submit', { search_term: input.value.trim(), search_source: form.className || 'search_form' });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllModals();
      return;
    }
    if (event.key !== 'Tab') return;
    const activeModal = document.querySelector('.ii-sub-modal.is-open, .ii-cart-drawer.is-open, .ii-qv-modal.is-open, .ii-mobile-nav.is-open');
    if (!activeModal) return;
    const focusable = Array.from(activeModal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((el) => el.offsetParent !== null || el === document.activeElement);
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest('form[data-product-form]');
    if (form && event.target.matches('[data-option-position]')) {
      updateVariantForm(form);
      return;
    }

    if (event.target.matches('[data-filter-submit]')) {
      const filterForm = event.target.closest('[data-filter-form]');
      if (filterForm) filterForm.submit();
      return;
    }

    if (event.target.matches('[data-sort-select]')) {
      const filterForm = document.querySelector('[data-filter-form]');
      if (filterForm) {
        const sortInput = filterForm.querySelector('[name="sort_by"]');
        if (sortInput) sortInput.value = event.target.value;
        filterForm.submit();
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        window.location.href = url.toString();
      }
      return;
    }

    if (event.target.matches('[data-search-filter-submit]')) {
      const searchFilterForm = event.target.closest('[data-search-filter-form]');
      if (searchFilterForm) searchFilterForm.submit();
      return;
    }

    if (event.target.matches('[data-search-sort]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
      return;
    }

    if (event.target.matches('[data-account-order-status]')) {
      filterAccountOrders(document);
    }
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-password-strength]')) {
      updatePasswordStrength(event.target);
      const field = event.target.closest('[data-field]');
      if (field) field.classList.remove('has-error');
      return;
    }
    if (event.target.closest('[data-validate-form]')) {
      const field = event.target.closest('[data-field]');
      if (field) field.classList.remove('has-error');
      return;
    }
    if (event.target.matches('[data-account-order-search]')) {
      filterAccountOrders(document);
      return;
    }
    if (event.target.matches('[data-cart-note]')) {
      clearTimeout(cartNoteTimer);
      const note = event.target.value;
      const drawer = cartDrawer();
      const status = drawer && drawer.querySelector('[data-cart-note-status]');
      const count = drawer && drawer.querySelector('[data-cart-note-count]');
      if (count) count.textContent = String(note.length);
      if (status) {
        status.textContent = 'Saving...';
        status.classList.remove('is-saved', 'is-error');
      }
      cartNoteTimer = setTimeout(() => {
        updateCartNote(note).then((cart) => {
          if (status) {
            status.textContent = cart ? 'Saved' : 'Could not save';
            status.classList.toggle('is-saved', Boolean(cart));
            status.classList.toggle('is-error', !cart);
          }
          announceCart(cart ? 'Order notes saved.' : 'Order notes could not be saved.');
        });
      }, 500);
      return;
    }
    if (event.target.matches('[data-cart-attribute]')) {
      clearTimeout(cartAttributesTimer);
      const drawer = cartDrawer();
      cartAttributesTimer = setTimeout(() => {
        const attributes = {};
        if (drawer) {
          drawer.querySelectorAll('[data-cart-attribute]').forEach((input) => {
            attributes[input.getAttribute('data-cart-attribute')] = input.value || '';
          });
          const giftToggle = drawer.querySelector('[data-cart-gift-toggle]');
          attributes['Gift order'] = giftToggle && giftToggle.checked ? 'Yes' : '';
        }
        updateCartAttributes(attributes);
      }, 500);
      return;
    }
  });

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-modal-close], [data-cart-close]');
    if (close) {
      event.preventDefault();
      if (close.closest('.ii-qv-modal')) {
        closeQuickView();
        return;
      }
      closeAllModals();
      return;
    }

    const recentOpen = event.target.closest('[data-recent-open]');
    if (recentOpen) {
      event.preventDefault();
      openUtilityPanel();
      return;
    }

    const mobileSearchOpen = event.target.closest('[data-mobile-search-open]');
    if (mobileSearchOpen) {
      event.preventDefault();
      const panel = document.getElementById('ii-mobile-search');
      if (!panel) return;
      panel.classList.add('is-open');
      showOverlay();
      window.setTimeout(() => {
        const input = panel.querySelector('[data-search-input]');
        if (input) input.focus();
      }, 0);
      return;
    }

    const mobileSearchClose = event.target.closest('[data-mobile-search-close]');
    if (mobileSearchClose) {
      event.preventDefault();
      closeAllModals();
      return;
    }

    if (event.target.closest('#ii-mobile-nav a[href]')) {
      closeAllModals();
      return;
    }

    const accountReturnLink = event.target.closest('[data-account-return-link]');
    if (accountReturnLink) {
      const returnTo = window.location.pathname + window.location.search + window.location.hash;
      const url = new URL(accountReturnLink.href, window.location.origin);
      url.searchParams.set('return_to', returnTo);
      accountReturnLink.href = url.toString();
      return;
    }

    const passwordToggle = event.target.closest('[data-password-toggle]');
    if (passwordToggle) {
      event.preventDefault();
      const wrap = passwordToggle.closest('.ii-account-form__input-wrap, .ii-account-auth__input-wrap, .ii-register__input-wrap, .ii-reset__input-wrap') || passwordToggle.parentElement;
      const input = wrap && wrap.querySelector('[data-password-input], input[type="password"], input[type="text"]');
      if (!input) return;
      const showing = input.type === 'text';
      input.type = showing ? 'password' : 'text';
      passwordToggle.setAttribute('aria-label', showing ? 'Show password' : 'Hide password');
      passwordToggle.innerHTML = showing ? '<i data-lucide="eye"></i>' : '<i data-lucide="eye-off"></i>';
      initLucide(passwordToggle);
      return;
    }

    const addressToggle = event.target.closest('[data-address-edit-toggle]');
    if (addressToggle) {
      event.preventDefault();
      const target = document.getElementById(addressToggle.getAttribute('aria-controls'));
      if (!target) return;
      const nextOpen = target.hidden;
      target.hidden = !nextOpen;
      addressToggle.setAttribute('aria-expanded', String(nextOpen));
      return;
    }

    const backToTop = event.target.closest('[data-back-to-top]');
    if (backToTop) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const announcementDismiss = event.target.closest('[data-announcement-dismiss]');
    if (announcementDismiss) {
      event.preventDefault();
      const bar = announcementDismiss.closest('[data-announcement]');
      const key = bar && bar.getAttribute('data-announcement-key');
      if (key) storageSet(key, 'hidden');
      if (bar) bar.hidden = true;
      return;
    }

    const copyCode = event.target.closest('[data-copy-code]');
    if (copyCode) {
      event.preventDefault();
      const code = copyCode.getAttribute('data-copy-code');
      if (navigator.clipboard && code) {
        navigator.clipboard.writeText(code).then(() => showToast(`${labels().copied || 'Copied'}: ${code}`));
      }
      return;
    }

    const copyLink = event.target.closest('[data-copy-link]');
    if (copyLink) {
      event.preventDefault();
      const url = copyLink.getAttribute('data-copy-link') || window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => showToast(labels().copied || 'Copied'));
      }
      return;
    }

    const shareLink = event.target.closest('[data-share-link]');
    if (shareLink) {
      event.preventDefault();
      const url = shareLink.getAttribute('data-share-link') || window.location.href;
      const title = shareLink.getAttribute('data-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title, url }).catch(() => {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => showToast(labels().copied || 'Copied'));
      }
      return;
    }

    const filterToggle = event.target.closest('[data-filter-toggle]');
    if (filterToggle) {
      event.preventDefault();
      const filterScope = filterToggle.closest('[id^="ii-"], main, section') || document;
      const filters = filterScope.querySelector('[data-filter-panel]');
      const nextOpen = filters && !filters.classList.contains('is-open');
      if (filters) filters.classList.toggle('is-open', nextOpen);
      filterScope.querySelectorAll('[data-filter-toggle]').forEach((button) => button.setAttribute('aria-expanded', String(Boolean(nextOpen))));
      if (window.innerWidth < 1024) {
        if (nextOpen) showOverlay();
        else hideOverlay();
      }
      return;
    }

    const viewMode = event.target.closest('[data-view-mode]');
    if (viewMode) {
      event.preventDefault();
      const mode = viewMode.getAttribute('data-view-mode') === 'list' ? 'list' : 'grid';
      const viewScope = viewMode.closest('[id^="ii-"], main, section') || document;
      viewScope.querySelectorAll('[data-collection-grid]').forEach((grid) => {
        const storageKey = grid.getAttribute('data-view-storage') || 'ii_collection_view';
        if (grid.getAttribute('data-persist-view') !== 'false') {
          storageSet(storageKey, mode);
        }
        grid.classList.toggle('is-list', mode === 'list');
      });
      viewScope.querySelectorAll('[data-view-mode]').forEach((button) => {
        const active = button.getAttribute('data-view-mode') === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      return;
    }

    const searchClear = event.target.closest('[data-search-clear]');
    if (searchClear) {
      event.preventDefault();
      const form = searchClear.closest('form');
      const input = form && form.querySelector('input[name="q"]');
      const box = form && form.querySelector('.ii-predictive-box');
      if (input) {
        input.value = '';
        input.focus();
      }
      if (box) {
        box.innerHTML = '';
        box.setAttribute('data-empty', 'true');
      }
      return;
    }

    const historyClear = event.target.closest('[data-search-history-clear]');
    if (historyClear) {
      event.preventDefault();
      storageRemove('ii_search_history');
      renderSearchHistory(document);
      return;
    }

    const voiceSearch = event.target.closest('[data-voice-search]');
    if (voiceSearch) {
      event.preventDefault();
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const form = voiceSearch.closest('form');
      const input = form && form.querySelector('input[name="q"]');
      if (!SpeechRecognition || !input) return;
      const recognition = new SpeechRecognition();
      recognition.lang = document.documentElement.lang || 'en-US';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      recognition.onresult = (event) => {
        input.value = event.results[0][0].transcript;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      recognition.start();
      return;
    }

    if (event.target === overlay()) {
      if (document.querySelector('.ii-qv-modal.is-open') && document.querySelector('.ii-cart-drawer.is-open')) {
        closeQuickView();
        return;
      }
      closeAllModals();
      return;
    }

    if (!event.target.closest('[data-mega-item]')) {
      closeMegaMenus();
    }

    const cartOpen = event.target.closest('#ii-cart-icon, [data-cart-open]');
    if (cartOpen) {
      event.preventDefault();
      openCart();
      return;
    }

    const emptyDealsLink = event.target.closest('[data-cart-empty-deals]');
    if (emptyDealsLink) {
      closeAllModals();
      return;
    }

    const giftToggle = event.target.closest('[data-cart-gift-toggle]');
    if (giftToggle) {
      const drawer = cartDrawer();
      const fields = drawer && drawer.querySelector('.ii-cart__gift-fields');
      if (fields) fields.hidden = !giftToggle.checked;
      const attributes = { 'Gift order': giftToggle.checked ? 'Yes' : '' };
      if (drawer) {
        drawer.querySelectorAll('[data-cart-attribute]').forEach((input) => {
          attributes[input.getAttribute('data-cart-attribute')] = giftToggle.checked ? (input.value || '') : '';
        });
      }
      updateCartAttributes(attributes);
      return;
    }

    const checkout = event.target.closest('.ii-cart__checkout');
    if (checkout) {
      track('begin_checkout', {});
      return;
    }

    const cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) {
      event.preventDefault();
      cartChange.disabled = true;
      changeCartLine(cartChange.getAttribute('data-cart-change'), Number(cartChange.getAttribute('data-quantity')))
        .catch((error) => {
          cartChange.disabled = false;
          const message = error && error.message ? error.message : (labels().cartError || 'Something went wrong. Please try again.');
          showToast(message);
          announceCart(message);
        });
      return;
    }

    const cartBundle = event.target.closest('[data-cart-add-bundle]');
    if (cartBundle) {
      event.preventDefault();
      const ids = (cartBundle.getAttribute('data-cart-add-bundle') || '').split(',').map((id) => id.trim()).filter(Boolean);
      if (ids.length === 0) return;
      cartBundle.disabled = true;
      addItems({ items: ids.map((id) => ({ id, quantity: 1 })) })
        .then(() => openCart())
        .catch((error) => {
          const message = error && error.message ? error.message : (labels().cartError || 'Something went wrong. Please try again.');
          showToast(message);
          announceCart(message);
        })
        .finally(() => {
          cartBundle.disabled = false;
        });
      return;
    }

    const recentCartAdd = event.target.closest('[data-cart-add-recent]');
    if (recentCartAdd) {
      event.preventDefault();
      const handle = recentCartAdd.getAttribute('data-cart-add-recent');
      if (!handle) return;
      recentCartAdd.disabled = true;
      fetch(`${root()}products/${encodeURIComponent(handle)}.js`)
        .then((res) => {
          if (!res.ok) throw new Error('Unable to load product.');
          return res.json();
        })
        .then((productData) => {
          const variant = cacheRecentVariant(handle, productData);
          if (!variant || !variant.id || variant.available === false) {
            throw new Error(labels().soldOut || 'Sold out');
          }
          return addItems({ items: [{ id: String(variant.id), quantity: 1 }] });
        })
        .then(() => openCart())
        .catch((error) => {
          const message = error && error.message ? error.message : (labels().cartError || 'Something went wrong. Please try again.');
          showToast(message);
          announceCart(message);
        })
        .finally(() => {
          recentCartAdd.disabled = false;
        });
      return;
    }

    const cartAdd = event.target.closest('[data-cart-add]');
    if (cartAdd) {
      event.preventDefault();
      cartAdd.disabled = true;
      addItems({ items: [{ id: String(cartAdd.getAttribute('data-cart-add')), quantity: 1 }] })
        .then(() => {
          if (cartAdd.closest('.ii-qv-modal')) {
            closeAllModals();
          }
          openCart();
        })
        .catch((error) => {
          const message = document.createElement('div');
          message.className = 'ii-cart__error';
          message.textContent = error && error.message ? error.message : (labels().cartError || 'Something went wrong. Please try again.');
          const target = cartAdd.closest('.ii-cart__upsell-item') || cartAdd.parentElement;
          if (target) target.appendChild(message);
          announceCart(message.textContent);
        })
        .finally(() => {
          cartAdd.disabled = false;
        });
      return;
    }

    const quickView = event.target.closest('[data-quick-view]');
    if (quickView) {
      event.preventDefault();
      event.stopPropagation();
      openQuickView(quickView.getAttribute('data-quick-view'), quickView);
      return;
    }

    const sticky = event.target.closest('[data-sticky-atc]');
    if (sticky) {
      event.preventDefault();
      const form = document.querySelector('form[data-product-form]');
      if (form) form.requestSubmit();
      return;
    }

    const bundle = event.target.closest('[data-bundle-add]');
    if (bundle) {
      event.preventDefault();
      const section = bundle.closest('[data-bundle-section]');
      const items = Array.from(section.querySelectorAll('[data-bundle-item]:checked')).map((input) => ({ id: String(input.value), quantity: 1 }));
      if (items.length === 0) return;
      bundle.disabled = true;
      addItems({ items })
        .then(() => openCart())
        .catch(() => {
          const message = section.querySelector('[data-bundle-message]');
          if (message) message.textContent = labels().cartError || 'Something went wrong. Please try again.';
        })
        .finally(() => {
          bundle.disabled = false;
        });
      return;
    }

    const qtyStep = event.target.closest('[data-qty-step]');
    if (qtyStep) {
      event.preventDefault();
      const input = qtyStep.parentElement && qtyStep.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      const nextValue = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(qtyStep.getAttribute('data-qty-step')));
      input.value = nextValue;
      return;
    }

    const quickViewQtyStep = event.target.closest('[data-qv-qty-step]');
    if (quickViewQtyStep) {
      event.preventDefault();
      const form = quickViewQtyStep.closest('form');
      const input = form && form.querySelector('input[name="quantity"]');
      if (!input) return;
      const min = Number(input.min || 1);
      const step = Number(quickViewQtyStep.getAttribute('data-qv-qty-step') || 0);
      input.value = Math.max(min, Number(input.value || min) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const descToggle = event.target.closest('[data-desc-toggle]');
    if (descToggle) {
      event.preventDefault();
      const content = descToggle.nextElementSibling;
      if (!content) return;
      const nextOpen = !content.classList.contains('is-open');
      descToggle.classList.toggle('is-open', nextOpen);
      descToggle.setAttribute('aria-expanded', String(nextOpen));
      content.classList.toggle('is-open', nextOpen);
      return;
    }

    const thumb = event.target.closest('[data-main-image]');
    if (thumb) {
      event.preventDefault();
      const main = document.getElementById('ii-main-product-image');
      if (main && thumb.getAttribute('data-main-image')) main.src = thumb.getAttribute('data-main-image');
      document.querySelectorAll('.ii-product__thumbnail').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }

    const quickViewThumb = event.target.closest('[data-qv-image]');
    if (quickViewThumb) {
      event.preventDefault();
      const media = quickViewThumb.closest('.ii-qv__media') || quickViewThumb.closest('.ii-qv-modal');
      const main = media && media.querySelector('[data-qv-main-image], #ii-qv-main-image, .ii-qv__main-image');
      const src = quickViewThumb.getAttribute('data-qv-image');
      setImageSource(main, src);
      if (media) {
        media.querySelectorAll('[data-qv-image]').forEach((item) => item.classList.remove('is-active'));
      }
      quickViewThumb.classList.add('is-active');
      return;
    }
  });
})();
